import React, { useEffect, Fragment } from "react";
import Loader from "../../../../components/styled-components/loader/loader";
import { MODULE_API } from "../../../../apis";
import { useState } from "react";
import DropDown from "../../../../components/styled-components/dropdown/dropdown";
import { defaultStyles } from "../../../../constants/style-constants/utils";
import {
  Radio,
  DatePicker,
  Button,
  Collapse,
  Select,
  Spin,
  InputNumber,
  AutoComplete,
  Input,
} from "antd";
import * as Styles from "./styles/allocationSubFormStyles";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import CurrencyCosts from "../../../../components/form/CurrencyForAssets";
import List from "../../../../newComponents/styledComponents/Table/List";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import { amortizationCalcultion } from "../../../../helpers/amortizationCalcultion";
import { ToolTipCreator } from "../../../../helpers/ToolTipCreator";
import FETCH from "../../../../utils/fetch";
import { AddOwnerModal } from "../../../../newComponents/ManageOwners/component/AddOwnerModal";
const { Option } = Select;
const Options = AutoComplete.Option;

const LiabilitySubForm = () => {
  let tabs2;
  const AllTabs = {
    "NAME AND OWNER": {
      name: "NAME AND OWNER",
      enabled: false,
      priority: 1,
    },
    "ADDITIONAL INFORMATION": {
      name: "ADDITIONAL INFORMATION",
      enabled: false,
      priority: 2,
    },
    LOAN: {
      name: "LOAN",
      enabled: false,
      priority: 3,
    },
    "ADJUSTABLE LOAN": {
      name: "ADJUSTABLE LOAN",
      enabled: false,
      priority: 4,
    },
    // PAYMENTS: {
    //   name: "PAYMENTS",
    //   enabled: false,
    //   priority: 5,
    // },
  };
  const AllTabsRealEstate = {
    "ASSET INFORMATION": {
      name: "ASSET INFORMATION",
      enabled: false,
      priority: 1,
    },
    "QUALIFIED ACCOUNT TYPE QUESTIONS": {
      name: "QUALIFIED ACCOUNT TYPE QUESTIONS",
      enabled: false,
      priority: 2,
    },
    "CONTRIBUTIONS OR DISTRIBUTIONS": {
      name: "CONTRIBUTIONS OR DISTRIBUTIONS",
      enabled: false,
      priority: 3,
    },
    "ADDITIONAL ASSET INFORMATION": {
      name: "ADDITIONAL ASSET INFORMATION",
      enabled: false,
      priority: 4,
    },
    "SELLING ASSET COSTS": {
      name: "SELLING ASSET COSTS",
      enabled: false,
      priority: 5,
    },
    "ASSET PERFORMANCE": {
      name: "ASSET PERFORMANCE",
      enabled: false,
      priority: 6,
    },
    "TAX AND LIQUIDITY": {
      name: "TAX AND LIQUIDITY",
      enabled: false,
      priority: 7,
    },
  };

  const history = useHistory();
  const { module } = useParams();
  const { id } = useParams();
  console.log("module", module, id);
  // --------------------states---------------
  const [moduleName, setModuleName] = useState(null);
  const [moduleId, setModuleId] = useState(null);

  const [loading, setIsLoading] = useState(false);
  const [loadingFields, setLoadingFields] = useState(false);

  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [tabsControl, setTabsControl] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabName, setActiveTabName] = useState("NAME AND OWNER");
  // const [totalTabs, setTotalTabs] = useState(0);
  const [activeStep1, setActiveStep1] = useState(0);

  const [submitBody, setSubmitBody] = useState({});
  const [fieldsData, setFieldsData] = useState({});
  const [typeOfLoanValue, setTypeOfLoanValue] = useState(false);

  //   ---------------functions----------------------
  const getAssetFields = async (assetName) => {
    setIsLoading(true);
    console.log("assetName....", assetName);
    const res = await MODULE_API.assetFiledDetails(assetName);
    setIsLoading(false);
    // console.log("result....", res);
    if (res) {
      res.attributes &&
        res.attributes.map((attribute) => {
          setFields((prevValue) => {
            return {
              ...prevValue,
              [attribute["groupName"]]: {
                ...(prevValue[attribute["groupName"]] || {}),
                [attribute["id"]]: attribute,
              },
            };
          });
        });
    }
  };
  const getAssetFieldsData = async (id) => {
    setIsLoading(true);
    setLoadingFields(true);
    console.log("asset id....", id);
    const res = await MODULE_API.fetchDetails(id);
    let resultArray = [];
    if (res && res.data) {
      setFieldsData(res.data);
      console.log("result....", res);
      if (res.data && res.data["Type of Loan"] === "Adjustable") {
        setTypeOfLoanValue(true);
        if (res.data["Adjustable Loan Details"]) {
          resultArray = res.data["Adjustable Loan Details"].map(
            (value, index) => ({
              loanAmount: value,
              dateofChange:
                res.data["Date of Rate Change"] &&
                res.data["Date of Rate Change"][index] &&
                res.data["Date of Rate Change"][index],
              newPercent:
                res.data["New Percent"] &&
                res.data["New Percent"][index] &&
                res.data["New Percent"][index],
              monthlyChanges:
                res.data["Monthly Payment Changes"] &&
                res.data["Monthly Payment Changes"][index] &&
                res.data["Monthly Payment Changes"][index],
            })
          );
        }
        console.log("resultArray", resultArray);
        // setCountAdjustableLoanDetails()
      }
    }
    setIsLoading(false);
    setLoadingFields(false);
  };
  function handlePreviousFormButton() {
    if (typeOfLoanValue === false && activeTabName === "PAYMENTS") {
      let temp = Object.values(tabsControl);
      let a = temp.indexOf(activeTabName);
      let b = Object.keys(tabsControl)[a - 2];
      setActiveTabName(tabsControl[b]);
      // console.log("previos step",b-1,a-1)
      setActiveStep1(a - 1);
    } else {
      let temp = Object.values(tabsControl);
      let a = temp.indexOf(activeTabName);
      let b = Object.keys(tabsControl)[a - 1];
      setActiveTabName(tabsControl[b]);
      setActiveStep1(a - 1);
    }
  }
  function tabsPrevNextControl() {
    let temp = {};
    if (module === "Real Estate") {
      temp = Object.keys(AllTabsRealEstate);
    } else {
      temp = Object.keys(AllTabs);
    }
    // let temp = Object.keys(AllTabs);
    tabs2 = tabs.map((tab) => tab.toUpperCase());
    let obj = {};
    tabs2.map((name) => {
      if (temp.includes(name)) {
        if (module === "Real Estate") {
          obj = {
            ...obj,
            [AllTabsRealEstate[name].priority]: AllTabsRealEstate[name].name,
          };
        } else {
          obj = {
            ...obj,
            [AllTabs[name].priority]: AllTabs[name].name,
          };
        }
      }
    });
    return obj;
  }
  useEffect(() => {
    setTabsControl(tabsPrevNextControl());
  }, [tabs]);
  function handleNextFormButton() {
    if (typeOfLoanValue === false && activeTabName === "LOAN") {
      console.log("active tab", typeOfLoanValue, activeTabName);
      let temp = Object.values(tabsControl);
      let a = temp.indexOf(activeTabName);
      let b = Object.keys(tabsControl)[a + 2];
      // setActiveTabName(tabsControl[b]);
      // setActiveStep1(b - 1);
    } else {
      let temp = Object.values(tabsControl);
      let a = temp.indexOf(activeTabName);
      let b = Object.keys(tabsControl)[a + 1];
      setActiveTabName(tabsControl[b]);
      setActiveStep1(b - 1);
    }
  }
  function yearsBetweenDates(startDate, endDate) {
    // Create Date objects for the start and end dates
    const start = new Date(startDate);
    const end = new Date(endDate);
    // Calculate the difference in milliseconds
    const differenceInMilliseconds = end - start;
    // Convert the difference in milliseconds to years (1000 ms * 60 sec * 60 min * 24 hr * 365.25 days)
    const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25;
    const yearsDifference = differenceInMilliseconds / millisecondsInYear;
    // Return the difference rounded to two decimal places
    const truncatedYearsDifference =
      Math.floor(yearsDifference * 10000) / 10000;
    return truncatedYearsDifference;
  }
  function calculatePMT(loanAmount, annualInterestRate, startDate, endDate) {
    // Convert annual interest rate to a decimal and calculate monthly interest rate
    let loanLengthYears = yearsBetweenDates(startDate, endDate);
    let paymentsPerYear = 12;
    const monthlyInterestRate = annualInterestRate / paymentsPerYear;
    // Calculate the total number of payments
    const totalPayments = loanLengthYears * paymentsPerYear;
    console.log("totalPayments", totalPayments);
    // If the interest rate is zero, return the simple division of loan amount by total payments
    if (monthlyInterestRate === 0) {
      return (loanAmount / totalPayments).toFixed(2); // Return positive value
    }
    console.log(
      "monthlyInterestRate",
      monthlyInterestRate,
      loanAmount,
      totalPayments
    );
    // Calculate the PMT using the formula (without the negative sign for positive result)
    const pmt =
      (loanAmount * monthlyInterestRate) /
      (1 - Math.pow(1 + monthlyInterestRate, -totalPayments));
    // Return the PMT rounded to two decimal places as a positive value
    console.log("pmt.toFixed(2)", pmt.toFixed(2));
    return pmt.toFixed(2);
  }
  const calculateAmortization = async (id, liability) => {
    if (!liability) {
      console.error("Missing required data.");
      return;
    }

    let keys = [
      "Month",
      "One-time Funding",
      "Snowball",
      liability["Nickname of Liabilities"],
      "End Balance",
    ];

    let temp = {};
    temp["header"] = keys;

    let nickname = "";
    if (
      moduleName === "Credit Card - Business" ||
      moduleName === "Credit Card - Personal" ||
      moduleName === "Credit - HELOC"
    ) {
      nickname = liability["Nickname of Credit"]
        ? liability["Nickname of Credit"]
        : "N/A";
    } else {
      nickname = liability["Nickname of Liabilities"]
        ? liability["Nickname of Liabilities"]
        : "N/A";
    }

    let initialLoanAmount = 0;
    if (
      moduleName === "Credit Card - Business" ||
      moduleName === "Credit Card - Personal" ||
      moduleName === "Credit - HELOC"
    ) {
      initialLoanAmount = liability["Credit Balance"] || 0;
    } else {
      initialLoanAmount = liability["Initial Loan Amount"] || 0;
    }
    initialLoanAmount =
      typeof initialLoanAmount === "string"
        ? parseFloat(initialLoanAmount.replace(/[$,]/g, "").trim()) || 0
        : initialLoanAmount;

    let interestRate = 0;
    if (
      moduleName === "Credit Card - Business" ||
      moduleName === "Credit Card - Personal" ||
      moduleName === "Credit - HELOC"
    ) {
      interestRate = +liability["Interest Rate (or APR%)"] || 0;
    } else {
      interestRate = +liability["Interest Rate"] || 0;
    }

    interestRate =
      typeof interestRate === "string"
        ? parseFloat(interestRate.replace(/[$,]/g, "").trim()) / 100 || 0
        : interestRate / 100;
    let startDate = liability["Start Date"]
      ? new Date(liability["Start Date"])
      : new Date();
    let maturityDate = liability["Maturity Date"]
      ? new Date(liability["Maturity Date"])
      : new Date();
    let monthlyPayment = 0;
    if (
      moduleName === "Credit Card - Business" ||
      moduleName === "Credit Card - Personal" ||
      moduleName === "Credit - HELOC"
    ) {
      monthlyPayment = liability["Monthly Payment"]
        ? typeof liability["Monthly Payment"] === "string"
          ? parseFloat(liability["Monthly Payment"].replace(/[$,]/g, "").trim())
          : liability["Monthly Payment"] // If it's already a number, use it directly
        : 0;
    } else {
      monthlyPayment = liability["Monthly Payment"]
        ? typeof liability["Monthly Payment"] === "string"
          ? parseFloat(liability["Monthly Payment"].replace(/[$,]/g, "").trim())
          : liability["Monthly Payment"] // If it's already a number, use it directly
        : 0;
      // calculatePMT(
      //     initialLoanAmount,
      //     interestRate,
      //     startDate,
      //     maturityDate,
      //   );
    }
    monthlyPayment =
      typeof monthlyPayment === "string"
        ? parseFloat(monthlyPayment.replace(/[$,]/g, "").trim()) || 0
        : monthlyPayment;

    let data = {
      total: 0,
      data: [],
      ILA: initialLoanAmount,
      InterestRate: interestRate,
      minimum: monthlyPayment,
      startDate: startDate,
      active: true,
    };

    let endBalance = initialLoanAmount;
    let newEndBal = endBalance;
    let iterationCount = 0;
    const maxIterations = 2000;
    let otpData = {};

    // oneTimeFunding && oneTimeFunding.forEach(
    //   val => (otpData[moment(val.date).format('MM-DD-YYYY')] = val.payment)
    // );

    let formattedLiabilityData = [];
    let cumulativeInterest = 0;
    let cumulativePrincipal = 0;
    // Iterate for a single liability
    while (data.ILA > 0 && iterationCount < maxIterations) {
      let startDate = data.startDate;
      let obj = { date: moment(startDate).format("MM-DD-YYYY") };
      startDate.setMonth(startDate.getMonth() + 1); // Default to monthly

      let oneTimeMonthFunding = 0;
      let weekDate = new Date(obj.date);
      let weekMonth = weekDate.getMonth();
      let weekYear = weekDate.getFullYear();

      for (let dateStr in otpData) {
        let otpDate = new Date(dateStr);
        let otpMonth = otpDate.getMonth();
        let otpYear = otpDate.getFullYear();
        if (weekMonth === otpMonth && weekYear === otpYear) {
          oneTimeMonthFunding = otpData[dateStr];
          break;
        }
      }

      let snowballAmount = monthlyPayment + oneTimeMonthFunding;
      let monthlyInterestRate = data.InterestRate / 12;
      let interestRatePaid = data.ILA * monthlyInterestRate;
      let principal = data.minimum;

      obj[nickname] = Math.round((interestRatePaid + principal) * 100) / 100;
      obj.interestRatePaid = parseFloat(interestRatePaid).toFixed(2);
      obj.principal = parseFloat(principal).toFixed(2);
      obj.remaining = parseFloat(data.ILA).toFixed(2);
      obj.principalPaid = parseFloat(principal - interestRatePaid).toFixed(2);
      data.total += Math.round(interestRatePaid * 100) / 100;
      data.ILA -= parseFloat(principal - interestRatePaid).toFixed(2);

      cumulativeInterest += parseFloat(interestRatePaid);
      cumulativePrincipal += parseFloat(obj.principalPaid);

      if (obj.remaining > 0) {
        formattedLiabilityData.push({
          date: obj.date,
          // valuepayable: obj[nickname],
          interestRate: +interestRate * 100,
          monthlyPayment: +obj.principal,
          interestRatePaid: +obj.interestRatePaid,
          principalPaid: +obj.principalPaid,
          balance: +obj.remaining,
          cumulativeInterest: cumulativeInterest,
          cumulativePrincipal: cumulativePrincipal,
        });
      }

      iterationCount++;
    }

    console.log(
      "Formatted Liability Data:",
      formattedLiabilityData,
      liability,
      moduleName
    );

    if (iterationCount >= maxIterations) {
      console.log("Exceeded maximum iteration limit. Terminating loop.");
      return;
    }
    await handleSubmitAmortization(id, formattedLiabilityData);
    // return formattedLiabilityData;
  };
  const handleSubmitAmortization = async (id, data) => {
    try {
      setIsLoading(true);
      if (data) {
        //  let payload={...data}
        let payload = {
          liabilityId: +id,
          amotizaion: data,
        };
        const response = await MODULE_API.postDebtData(id, payload);
        console.log("response", response);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  async function handleSubmit() {
    setIsLoading(true);
    console.log("moduleName", submitBody);
    if (moduleName && moduleId === null) {
      console.log("create api");
      try {
        if (moduleName && moduleId === null) {
          const moduleNew = await MODULE_API.addAsset(moduleName, {
            clientModules: [{ ...submitBody }],
          });
          let liablilityId =
            moduleNew &&
            moduleNew.clientModules &&
            moduleNew.clientModules[0] &&
            moduleNew.clientModules[0].id;

          await calculateAmortization(liablilityId, submitBody);
          setIsLoading(false);
          if (moduleNew && moduleNew.status === 400) {
            if (moduleNew.message) {
              swal({
                title: "Error",
                text: moduleNew.message,
                icon: "error",
                buttons: true,
                dangerMode: true,
              });
            }
            return;
          }
          history.push("/liabilities_credit");
        }
      } catch (error) {
        setIsLoading(false);
        swal({
          title: "Error",
          text: "Error while Saving Module",
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
      }
    }
    if (moduleId && moduleName) {
      console.log("updateApi");

      try {
        const res = await MODULE_API.updateClientModule(moduleId, {
          ...submitBody,
        });
        let payloadForAmortization = {
          "Monthly Payment":
            submitBody && submitBody["Monthly Payment"]
              ? submitBody["Monthly Payment"]
              : (fieldsData && fieldsData["Monthly Payment"]) || 0,
          "Start Date":
            submitBody && submitBody["Start Date"]
              ? submitBody["Start Date"]
              : (fieldsData && fieldsData["Start Date"]) || new Date(),
          "Maturity Date":
            submitBody && submitBody["Maturity Date"]
              ? submitBody["Maturity Date"]
              : (fieldsData && fieldsData["Maturity Date"]) || new Date(),
        };
        if (
          moduleName === "Credit Card - Business" ||
          moduleName === "Credit Card - Personal" ||
          moduleName === "Credit - HELOC"
        ) {
          payloadForAmortization["Nickname of Credit"] =
            submitBody && submitBody["Nickname of Credit"]
              ? submitBody["Nickname of Credit"]
              : fieldsData && fieldsData["Nickname of Credit"];
          payloadForAmortization["Credit Balance"] =
            submitBody && submitBody["Credit Balance"]
              ? submitBody["Credit Balance"]
              : fieldsData && fieldsData["Credit Balance"];
          payloadForAmortization["Interest Rate (or APR%)"] =
            submitBody && submitBody["Interest Rate (or APR%)"]
              ? submitBody["Interest Rate (or APR%)"]
              : fieldsData && fieldsData["Interest Rate (or APR%)"];
        } else {
          payloadForAmortization["Nickname of Liabilities"] =
            submitBody && submitBody["Nickname of Liabilities"]
              ? submitBody["Nickname of Liabilities"]
              : fieldsData && fieldsData["Nickname of Liabilities"];
          payloadForAmortization["Initial Loan Amount"] =
            submitBody && submitBody["Initial Loan Amount"]
              ? submitBody["Initial Loan Amount"]
              : fieldsData && fieldsData["Initial Loan Amount"];
          payloadForAmortization["Interest Rate"] =
            submitBody && submitBody["Interest Rate"]
              ? submitBody["Interest Rate"]
              : fieldsData && fieldsData["Interest Rate"];
        }

        if (submitBody && payloadForAmortization) {
          await calculateAmortization(moduleId, payloadForAmortization);
        }
        setIsLoading(false);
        if (res && res.status === 400) {
          if (res.message) {
            swal({
              title: "Error",
              text: res.message,
              icon: "error",
              buttons: true,
              dangerMode: true,
            });
          }
          return;
        }
        history.push("/liabilities_credit");
      } catch (error) {
        setIsLoading(false);
        swal({
          title: "Error",
          text: "Error while Saving Module",
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
      }
    }
  }

  function currentTab(tab) {
    tabs2 = tabs.map((tab) => tab.toUpperCase());
    console.log("currentTab", tab, tabs2.includes(tab));
    console.log("tabs2", tabs2, "\n", "currentTab", `'${tab}'`);

    let cond = tabs2.includes(tab);
    if (cond) {
      let ind = tabs2.indexOf(tab);
      console.log("tabs.indexOf(tab)", tabs2.indexOf(tab));
      setActiveTabIndex(ind);
      setActiveTabName(tab);
    }
  }

  useEffect(() => {
    const validKeys = Object.keys(fields).filter(
      (key) => key && key !== "null" && key !== null && key !== undefined // Ensure key itself is valid
    );
    console.log(validKeys, "validKeys");
    setTabs(validKeys);
    // setTabs(Object.keys(fields));
  }, [fields]);
  useEffect(() => {
    if (module === "Real Estate") {
      currentTab("ASSET INFORMATION");
    } else {
      currentTab("NAME AND OWNER");
    }
  }, [tabs]);
  useEffect(() => {
    let tabs2 = tabs.map((item) => item.toUpperCase());
    let temp = tabs2.indexOf(activeTabName);
    if (temp !== -1) {
      setActiveTabIndex(temp);
    }
  }, [activeTabName]);

  //   --------------LOG useEffects-------------------
  useEffect(() => {
    console.log("fields", fields);
  }, [fields]);
  useEffect(() => {
    if (module) {
      getAssetFields(module);
      setModuleName(module || null);
      if (module === "Real Estate") {
        setActiveTabName("ASSET INFORMATION");
      }
    }
    if (id) {
      getAssetFieldsData(id);
      setModuleId(id || null);
      if (module === "Real Estate") {
        setActiveTabName("ASSET INFORMATION");
      }
    }
  }, [module, id]);
  const filteredTabs = (tabs) => {
    // Check if "PAYMENTS" exists, then remove it if present
    if (tabs.PAYMENTS) {
      const { PAYMENTS, ...rest } = tabs; // Remove PAYMENTS key
      return rest;
    }
    return tabs; // Return the original if PAYMENTS is not found
  };

  const hasCredit = module && /credit/i.test(module); // case-insensitive "credit" check

  function isNonEmpty(obj, key) {
    return (
      obj &&
      obj.hasOwnProperty(key) &&
      obj[key] != null &&
      String(obj[key]).trim() !== ""
    );
  }

  const creditFieldsValid =
    (isNonEmpty(submitBody, "Nickname of Credit") ||
      isNonEmpty(fieldsData, "Nickname of Credit")) &&
    (isNonEmpty(submitBody, "Credit Limit") ||
      isNonEmpty(fieldsData, "Credit Limit")) &&
    (isNonEmpty(submitBody, "Credit Balance") ||
      isNonEmpty(fieldsData, "Credit Balance")) &&
    (isNonEmpty(submitBody, "Interest Rate (or APR%)") ||
      isNonEmpty(fieldsData, "Interest Rate (or APR%)"));

  const liabilitiesFieldsValid =
    (isNonEmpty(submitBody, "Nickname of Liabilities") ||
      isNonEmpty(fieldsData, "Nickname of Liabilities")) &&
    (isNonEmpty(submitBody, "Initial Loan Amount") ||
      isNonEmpty(fieldsData, "Initial Loan Amount")) &&
    (isNonEmpty(submitBody, "Start Date") ||
      isNonEmpty(fieldsData, "Start Date")) &&
    (isNonEmpty(submitBody, "Maturity Date") ||
      isNonEmpty(fieldsData, "Maturity Date")) &&
    (isNonEmpty(submitBody, "Interest Rate") ||
      isNonEmpty(fieldsData, "Interest Rate"));

  const opacityValue = hasCredit
    ? creditFieldsValid
      ? 1
      : 0.5
    : liabilitiesFieldsValid
    ? 1
    : 0.5;

  const getStep1Opacity = (module, submitBody, fieldsData) => {
    if (/credit/i.test(module)) {
      const nickname =
        (submitBody &&
          submitBody["Nickname of Credit"] &&
          submitBody["Nickname of Credit"].trim() !== "") ||
        (fieldsData &&
          fieldsData["Nickname of Credit"] &&
          fieldsData["Nickname of Credit"].trim() !== "");

      return nickname ? 1 : 0.5;
    } else {
      const nickname =
        (submitBody &&
          submitBody["Nickname of Liabilities"] &&
          submitBody["Nickname of Liabilities"].trim() !== "") ||
        (fieldsData &&
          fieldsData["Nickname of Liabilities"] &&
          fieldsData["Nickname of Liabilities"].trim() !== "");

      return nickname ? 1 : 0.5;
    }
  };

  function isStep1Disabled(module, submitBody, fieldsData) {
    if (/credit/i.test(module)) {
      return !(
        (submitBody &&
          submitBody["Nickname of Credit"] &&
          submitBody["Nickname of Credit"].trim() !== "") ||
        (fieldsData &&
          fieldsData["Nickname of Credit"] &&
          fieldsData["Nickname of Credit"].trim() !== "")
      );
    } else {
      return !(
        (submitBody &&
          submitBody["Nickname of Liabilities"] &&
          submitBody["Nickname of Liabilities"].trim() !== "") ||
        (fieldsData &&
          fieldsData["Nickname of Liabilities"] &&
          fieldsData["Nickname of Liabilities"].trim() !== "")
      );
    }
  }

  return (
    <div style={{ position: "relative" }}>
      {/* <AssetLissting/> */}
      <hr />
      <TabNavigationComponent
        tabs={tabs}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
        activeTabName={activeTabName}
        setActiveTabName={setActiveTabName}
        activeStep1={activeStep1}
        currentTab={currentTab}
        AllTabs={
          module === "Real Estate"
            ? AllTabsRealEstate
            : module === "Credit Card - Personal" ||
              module === "Credit Card - Business" ||
              module === "Credit - HELOC"
            ? filteredTabs(AllTabs)
            : AllTabs
        }
        typeOfLoanValue={typeOfLoanValue}
        module={module}
      />
      <hr />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "1rem",
        }}
      >
        {loadingFields ? <Spin size="large" /> : null}
      </div>
      <form>
        {tabs.length > 0 && (
          <FormCreator
            setTypeOfLoanValue={setTypeOfLoanValue}
            data={fields[tabs[activeTabIndex]]}
            values={fieldsData}
            title={tabs[activeTabIndex]}
            setSubmitBody={setSubmitBody}
            activeTabName={activeTabName}
          />
        )}
      </form>
      {console.log("tabs.length>>", tabs.length)}
      {tabs.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "3rem 3rem",
            width: "96%",
          }}
        >
          <Button
            onClick={() => {
              if (
                module === "Real Estate" &&
                activeTabName == "ASSET INFORMATION"
              ) {
                history.goBack();
              } else if (activeTabName == "NAME AND OWNER") {
                history.goBack();
              } else {
                handlePreviousFormButton();
              }
            }}
            style={{
              backgroundColor: "transparent",
              color: "#2a3da3",
              borderRadius: "8px",
              border: "1px solid #2a3da3",
              width: "250px",
              height: "3rem",
              fontSize: "16px",
              fontWeight: "500",
              fontFamily: "Poppins",
            }}
            // disabled={
            //   module === "Real Estate"
            //     ? activeTabName == "ASSET INFORMATION"
            //     : activeTabName == "NAME AND OWNER"
            // }
          >
            Previous
          </Button>

          {(activeTabName === "NAME AND OWNER" && tabs.length === 1) ||
          (activeTabName === "LOAN" && tabs.length === 2) ||
          (activeTabName === "ADJUSTABLE LOAN" && tabs.length === 3) ||
          (activeTabName === "ADJUSTABLE LOAN" && tabs.length === 4) ||
          (activeTabName === "LOAN" &&
            tabs.length === 4 &&
            typeOfLoanValue === false) ||
          (activeTabName === "ADDITIONAL INFORMATION" &&
            (module === "Credit Card - Personal" ||
              module === "Credit Card - Business" ||
              module === "Credit - HELOC")) ||
          (activeTabName === "TAX AND LIQUIDITY" &&
            module === "Real Estate") ? (
            <Button
              onClick={() => {
                handleSubmit();
              }}
              // style={{
              //   backgroundColor: "#2a3da3",
              //   color: "white",
              //   borderRadius: "8px",
              //   fontFamily: "Poppins",
              //   width: "250px",
              //   height: "3rem",
              //   fontSize: "16px",
              //   fontWeight: "500",
              // }}
              // { ["Credit Limit", "Nickname of Credit", "Credit Balance", "Interest Rate (or APR%)", "Nickname of Liabilities", "Initial Loan Amount", "Start Date", "Maturity Date", "Interest Rate"].includes(item.name) && (

              style={{
                backgroundColor: "#2a3da3",
                color: "white",
                borderRadius: "8px",
                fontFamily: "Poppins",
                width: "250px",
                height: "3rem",
                fontSize: "16px",
                fontWeight: "500",
                opacity: opacityValue,
                //   opacity: (submitBody &&
                //     ( submitBody.hasOwnProperty("Nickname of Credit") && submitBody.hasOwnProperty("Credit Limit") && submitBody.hasOwnProperty("Credit Balance") && submitBody.hasOwnProperty("Interest Rate (or APR%)") )) ||
                //     (fieldsData &&
                //       ( fieldsData.hasOwnProperty("Nickname of Credit") && fieldsData.hasOwnProperty("Credit Limit") && fieldsData.hasOwnProperty("Credit Balance") && fieldsData.hasOwnProperty("Interest Rate (or APR%)")))
                //       ? 1
                //       : 0.5,
              }}
              disabled={
                hasCredit ? !creditFieldsValid : !liabilitiesFieldsValid
              }
              // disabled={
              //   !(submitBody &&
              //    ( submitBody.hasOwnProperty("Nickname of Credit") && submitBody.hasOwnProperty("Credit Limit") && submitBody.hasOwnProperty("Credit Balance") && submitBody.hasOwnProperty("Interest Rate (or APR%)")))
              // }
            >
              Submit
            </Button>
          ) : (
            <Button
              onClick={handleNextFormButton}
              style={{
                backgroundColor: "#2a3da3",
                color: "white",
                borderRadius: "8px",
                fontFamily: "Poppins",
                width: "250px",
                height: "3rem",
                fontSize: "16px",
                fontWeight: "500",
                opacity:
                  activeTabName === "NAME AND OWNER"
                    ? getStep1Opacity(module, submitBody, fieldsData)
                    : opacityValue,
              }}
              disabled={
                activeTabName === "NAME AND OWNER"
                  ? isStep1Disabled(module, submitBody, fieldsData) // ✅ Step1
                  : hasCredit
                  ? !creditFieldsValid // ✅ Step2 (Credit)
                  : !liabilitiesFieldsValid // ✅ Step2 (Liabilities)
              }
            >
              Next
            </Button>
          )}
        </div>
      )}
      <Loader isLoading={loading} />
    </div>
  );
};

const FormCreator = ({
  data,
  title,
  setSubmitBody,
  activeTabName,
  values,
  setTypeOfLoanValue,
  alltabs,
}) => {
  const { Panel } = Collapse;
  // ------------------HOOKS--------------
  const [adjustableTable, setAdjustableTable] = useState([]);
  const [adjustableData, setAdjustableData] = useState(null);
  const [payloadAdjustable, setPayloadAdjustable] = useState(null);

  const [inputFields, setInputFields] = useState([]);
  const [groupedFields, setGroupedFields] = useState({});
  const [payload, setPayload] = useState({});

  const [attributeValues, setAttributeValues] = useState({});
  const [additionalPrincipalPayments, setAdditionalPrincipalPayments] =
    useState({});
  const [disbursementDate, setDisbursementDate] = useState({});
  const [loading, setLoading] = useState(false);
  const [ownerList, setOwnerList] = useState([]);
  const [formDataOwner, setFormDataOwner] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [adjustableLoanDetails, setAdjustableLoanDetails] = useState({});
  const [additionalLoanInformation, setAdditionalLoanInformation] = useState(
    {}
  );
  const [additionalCreditCardInformation, setAdditionalCreditCardInformation] =
    useState({});

  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  useEffect(() => {
    setInputFields(Object.keys(data));
  }, [data]);

  const handleChangeOwner = (name, value) => {
    setFormDataOwner({
      ...formDataOwner,
      [name]: value,
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFormDataOwner(null);
  };

  const handleSave = async () => {
    setIsModalOpen(false);
    try {
      let payload = {
        ...formDataOwner,
      };

      setLoading(true);
      let data = await MODULE_API.addAsset("Owners and Entities", {
        clientModules: [{ ...payload }],
      });
      if (data && data.statusCode === 201) {
        swal("Success", "Owner Details Added Successfully.", "success");
        await getOwnersDetails(1);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setFormDataOwner(null);
  };

  const getOwnersDetails = async (page) => {
    try {
      // setLoading(true);
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Owners and Entities&page=${page}&limit=30&clientId=${ID}`
            : `?module=Owners and Entities&page=${page}&limit=30`,
        body: {},
      });
      if (datares && datares.records) {
        setOwnerList(datares.records);
      }
      // setLoading(false);
    } catch (error) {
      console.log(error);
      // setLoading(false);
    }
  };

  useEffect(() => {
    getOwnersDetails(1);
  }, []);

  useEffect(() => {
    let obj = { ...payload };

    if (payloadAdjustable) {
      obj["Adjustable Loan Details"] = payloadAdjustable.loanAmount || "";
      obj["Date of Rate Change"] = payloadAdjustable.dateofChange || new Date();
      obj["New Percent"] = payloadAdjustable.newPercent || "";
      obj["Monthly Payment Changes"] = payloadAdjustable.monthlyChanges || "";
    }
    if (
      module === "Credit Card - Business" ||
      module === "Credit Card - Personal" ||
      module === "Credit - HELOC"
    ) {
      obj["Credit Card Open Date"] =
        payload["Credit Card Open Date"] || new Date();
    }
    console.log("objjjjjjj", obj, payloadAdjustable);
    setSubmitBody(obj);
  }, [payload]);

  useEffect(() => {
    // setSubmitBody(values);
    setAttributeValues(values);
    // if (values && values["Adjustable Loan Details"]) {
    //   // console.log("values inside", values["Adjustable Loan Details"].length);
    //   // setCountAdjustableLoanDetails(values["Adjustable Loan Details"].length);
    //   // setNewObjectAdjustableLoanDetails(newObjectadjustableLoanDetails);
    //   // setCollapseObjectsAdjustableLoanDetails((prevObjects) => [
    //   //   ...prevObjects,
    //   //   newObjectAdditionalPrincipalPayments,
    //   // ]);
    // }
    let resultArray = [];
    if (values && values["Type of Loan"] === "Adjustable") {
      setTypeOfLoanValue(true);
      if (values["Adjustable Loan Details"]) {
        resultArray = values["Adjustable Loan Details"].map((value, index) => ({
          loanAmount: value,
          dateofChange:
            values["Date of Rate Change"] &&
            values["Date of Rate Change"][index] &&
            values["Date of Rate Change"][index],
          newPercent:
            values["New Percent"] &&
            values["New Percent"][index] &&
            values["New Percent"][index],
          monthlyChanges:
            values["Monthly Payment Changes"] &&
            values["Monthly Payment Changes"][index] &&
            values["Monthly Payment Changes"][index],
        }));
      }
    }
    console.log("resultArray 22", resultArray);
    setAdjustableTable(resultArray);
  }, [values]);
  const adjustableCols = [
    {
      title: "Adjustable Loan Details",
      dataIndex: "loanAmount",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Date of Rate Change",
      dataIndex: "dateofChange",
      render: (record) =>
        record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },
    {
      title: "New Percent",
      dataIndex: "newPercent",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monthly Payment Changes",
      dataIndex: "monthlyChanges",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <div
            key={index}
            style={{
              outline: "none",
              border: "none",
              backgroundColor: "red",
              padding: "6px 12px",
              borderRadius: "10px",
              cursor: "pointer",
              color: "white",
              width: "fit-content",
            }}
            onClick={() => handleRemoveClick(index)}
          >
            Remove
          </div>
        );
      },
    },
  ];
  const handleRemoveClick = (index) => {
    // Create a copy of the array
    const newArray = [...adjustableTable];
    // Remove the object at the specified index
    newArray.splice(index, 1);
    // Update the state with the new array
    setAdjustableTable(newArray);
  };
  const orderOfNamesPayment = [
    "Initial Loan Amount",
    "Credit Limit",
    "Credit Balance",
    "Start Date",
    "Maturity Date",
    "Interest Rate",
    "Monthly Payment",
    "Interest Rate (or APR%)",
    "Draw Period Start Date",
    "Draw Period End Date",
    "Start Date of Repayment",
    "End Date of Repayment",
    "Total Credit Available",
    "Name Of financial Institiutation",
    "Account Number",
    "Credit Card Open Date",
    "Loan Balance",
    "Monthly Payment Due",
    "Disbursement Dates",
  ];

  const sortedDataNamesPayment = Object.values(data).sort((a, b) => {
    return (
      orderOfNamesPayment.indexOf(a.name) - orderOfNamesPayment.indexOf(b.name)
    );
  });
  const dataObjectPayment = {};
  for (const item of sortedDataNamesPayment) {
    dataObjectPayment[item.name] = item;
  }
  const orderOfNamesInfo = [
    // "Credit Limit",
    // "Credit Balance",
    // "Monthly Payment",
    // "Interest Rate (or APR%)",
    "Name of Issuer",
    "Phone Number of Issuer",
    "Annual Fee",
    "Credit Card Rewards Program",
    "Point Balance",
    "Point Expiration",
    "Additional Notes about Credit Card",
  ];

  const sortedDataNamesInfo = Object.values(data).sort((a, b) => {
    return orderOfNamesInfo.indexOf(a.name) - orderOfNamesInfo.indexOf(b.name);
  });

  const dataObjectInfo = {};
  for (const item of sortedDataNamesInfo) {
    dataObjectInfo[item.name] = item;
  }
  console.log("dataObjectInfo", dataObjectInfo);
  const orderOfNamesInfoRealEstate = [
    "Name of Asset",
    "Owner",
    "Account Type/Titled",
    "Account Number",
    "This Asset produces Income",
    "This Asset has a Loan",
  ];

  const sortedDataNames = Object.values(data).sort((a, b) => {
    return (
      orderOfNamesInfoRealEstate.indexOf(a.name) -
      orderOfNamesInfoRealEstate.indexOf(b.name)
    );
  });

  const dataObject = {};
  for (const item of sortedDataNames) {
    dataObject[item.name] = item;
  }
  console.log("dataObjectInfo 22", dataObject);

  useEffect(() => {
    inputFields.map((item) => {
      if (data[item] && data[item]["formGroupName"]) {
        setGroupedFields((prevValue) => {
          return {
            ...prevValue,
            [data[item].formGroupName]: {
              ...prevValue[data[item].formGroupName],
              [data[item].id]: data[item],
            },
          };
        });
      }
      if (
        data[item] &&
        data[item]["formGroupName"] &&
        data[item]["formGroupName"] === "Additional Principal Payments"
      ) {
        setAdditionalPrincipalPayments((prevValue) => {
          return {
            ...prevValue,
            [data[item].formGroupName]: {
              ...prevValue[data[item].formGroupName],
              [data[item].id]: data[item],
            },
          };
        });
      }
      if (
        data[item] &&
        data[item]["formGroupName"] &&
        data[item]["formGroupName"] === "Disbursment Dates"
      ) {
        setDisbursementDate((prevValue) => {
          return {
            ...prevValue,
            [data[item].formGroupName]: {
              ...prevValue[data[item].formGroupName],
              [data[item].id]: data[item],
            },
          };
        });
      }
      if (
        data[item] &&
        data[item]["formGroupName"] &&
        data[item]["formGroupName"] === "Adjustable Loan Details"
      ) {
        setAdjustableLoanDetails((prevValue) => {
          return {
            ...prevValue,
            [data[item].formGroupName]: {
              ...prevValue[data[item].formGroupName],
              [data[item].id]: data[item],
            },
          };
        });
      }
      if (
        data[item] &&
        data[item]["formGroupName"] &&
        data[item]["formGroupName"] === "Additional Loan Information"
      ) {
        setAdditionalLoanInformation((prevValue) => {
          return {
            ...prevValue,
            [data[item].formGroupName]: {
              ...prevValue[data[item].formGroupName],
              [data[item].id]: data[item],
            },
          };
        });
      }
      if (
        data[item] &&
        data[item]["formGroupName"] &&
        data[item]["formGroupName"] === "Additional Credit Card Information"
      ) {
        setAdditionalCreditCardInformation((prevValue) => {
          return {
            ...prevValue,
            [data[item].formGroupName]: {
              ...prevValue[data[item].formGroupName],
              [data[item].id]: data[item],
            },
          };
        });
      }
    });
  }, [data, inputFields]);

  useEffect(() => {
    // setSubmitBody(values);
    if (
      module === "Credit Card - Business" ||
      module === "Credit Card - Personal" ||
      module === "Credit - HELOC"
    ) {
      if (
        (payload["Credit Balance"] && payload["Interest Rate (or APR%)"]) ||
        (attributeValues["Credit Balance"] &&
          attributeValues["Interest Rate (or APR%)"])
      ) {
        calculateMonthlyPaymentcard();
      }
    } else {
      if (
        (payload["Initial Loan Amount"] && payload["Interest Rate"]) ||
        payload["Maturity Date"] ||
        (attributeValues["Initial Loan Amount"] &&
          attributeValues["Interest Rate"]) ||
        attributeValues["Maturity Date"]
      ) {
        calculateMonthlyPayment();
      }
    }
    const value = amortizationCalcultion(payload, module);
    if (value && value.balance) {
      setPayload((prevValue) => {
        return {
          ...prevValue,
          ["Loan Balance"]: isNaN(value.balance)
            ? "0"
            : value.balance.toString() === "Infinity"
            ? "0"
            : value.balance.toString(),
        };
      });
    }
  }, [
    payload["Interest Rate"],
    attributeValues["Interest Rate"],
    payload["Initial Loan Amount"],
    payload["Maturity Date"],
    attributeValues["Maturity Date"],
    attributeValues["Initial Loan Amount"],
    payload["Credit Balance"],
    attributeValues["Credit Balance"],
    payload["Interest Rate (or APR%)"],
    attributeValues["Interest Rate (or APR%)"],
  ]);

  useEffect(() => {
    if (payload["Maturity Date"] || payload["Start Date"]) {
      calculateDifference();
    }
  }, [payload["Start Date"], payload["Maturity Date"]]);

  function calculateMonthlyPayment() {
    console.log("payload monthly", payload);

    let Interest =
      payload["Interest Rate"] || attributeValues["Interest Rate"] || 0;
    let loanAmount =
      payload["Initial Loan Amount"] ||
      attributeValues["Initial Loan Amount"] ||
      0;
    let Start =
      payload["Start Date"] || attributeValues["Start Date"] || new Date();
    let Maturity =
      payload["Maturity Date"] ||
      attributeValues["Maturity Date"] ||
      new Date();

    let StartDate1 = new Date(Start);
    let MaturityDate1 = new Date(Maturity);

    let numberOfPayments = 0;

    if (StartDate1 && MaturityDate1) {
      // Calculate the difference in months
      numberOfPayments =
        (MaturityDate1.getFullYear() - StartDate1.getFullYear()) * 12;
      numberOfPayments -= StartDate1.getMonth();
      numberOfPayments += MaturityDate1.getMonth();

      // Check if there's a partial month based on days
      if (MaturityDate1.getDate() >= StartDate1.getDate()) {
        numberOfPayments += 1;
      }
    }

    console.log("numberOfPayments", numberOfPayments);

    let rate = Interest / 100 / 12;
    let monthlyRate = Interest / 100 / 12;
    // Using the formula to calculate the monthly payment
    let MonthlyPayment =
      (loanAmount * monthlyRate) /
      (1 - Math.pow(1 + monthlyRate, -numberOfPayments));
    // loanAmount * rate / (1 - Math.pow(1 + rate, -numberOfPayments));
    console.log("MonthlyPayment", MonthlyPayment);
    MonthlyPayment =
      isNaN(MonthlyPayment) || !isFinite(MonthlyPayment)
        ? 0
        : MonthlyPayment.toFixed(2);

    setPayload((prevValue) => {
      return {
        ...prevValue,
        ["Monthly Payment"]: isNaN(MonthlyPayment)
          ? "0"
          : MonthlyPayment.toString() === "Infinity"
          ? "0"
          : MonthlyPayment.toString(),
      };
    });

    console.log(
      "MonthlyPayment>>>>",
      MonthlyPayment,
      Interest,
      loanAmount,
      Start,
      Maturity
    );

    return MonthlyPayment;
  }
  const calculateMonthlyPaymentcard = () => {
    const loanBalance =
      payload["Credit Balance"] || attributeValues["Credit Balance"] || 0;
    const interestRate =
      payload["Interest Rate (or APR%)"] ||
      attributeValues["Interest Rate (or APR%)"] ||
      0;
    const annualFee = 2;

    // Calculate monthly interest rate
    const monthlyInterestRate = interestRate / 100 / 12;

    // Monthly payment formula: interest component + monthly portion of the annual fee
    const monthlyPayment =
      loanBalance * monthlyInterestRate + loanBalance * (annualFee / 100);
    setPayload((prevValue) => {
      return {
        ...prevValue,
        ["Monthly Payment"]: isNaN(monthlyPayment)
          ? "0"
          : monthlyPayment.toFixed(2).toString() === "Infinity"
          ? "0"
          : monthlyPayment.toFixed(2).toString(),
      };
    });
  };
  function calculateDifference() {
    // let Start =
    //   (payload["Start Date"] && new Date(payload["Start Date"])) ||
    //   (attributeValues["Start Date"] &&
    //     new Date(attributeValues["Start Date"])) ||
    //   new Date();
    let Start = new Date();
    let Maturity =
      (payload["Maturity Date"] && new Date(payload["Maturity Date"])) ||
      (attributeValues["Maturity Date"] &&
        new Date(attributeValues["Maturity Date"])) ||
      new Date();

    // Calculate the difference in years
    let yearsDiff = Maturity.getFullYear() - Start.getFullYear();

    // Calculate the difference in months
    let monthsDiff = Maturity.getMonth() - Start.getMonth();
    // Adjust for the case where the start date's day is greater than the maturity date's day
    if (Maturity.getDate() < Start.getDate()) {
      monthsDiff--;
    }

    // If monthsDiff is negative, adjust the years and months accordingly
    if (monthsDiff < 0) {
      yearsDiff--;
      monthsDiff += 12;
    }

    // Adjust for cases where monthsDiff is negative or end date is in the next month
    // if (
    //   (Maturity.getDate() < Start.getDate() &&
    //     Maturity.getMonth() === Start.getMonth()) ||
    //   Maturity.getMonth() < Start.getMonth()
    // ) {
    //   monthsDiff--;
    // }

    console.log("Years difference:", yearsDiff, "Years", monthsDiff, "Months");

    setPayload((prevValue) => {
      return {
        ...prevValue,
        ["Length of Loan (No of years remaining)"]:
          yearsDiff + " Years " + Math.max(0, monthsDiff) + " Months",
      };
    });
  }

  // const AlltabsCatch = alltabs["ADJUSTABLE LOAN"].enabled;
  function handleInputFields(inputName, value) {
    // setPayload((prevValue) => {
    //   if (inputName === "Type of Loan" && value === "Adjustable") {
    //     setTypeOfLoanValue(true);
    //     console.log("true valueee", value);
    //   } else if (value === "Fixed") {
    //     console.log("false valueee", value);
    //     setTypeOfLoanValue(false);
    //   }
    //   return { ...prevValue, [inputName]: value };
    // });
    setPayload((prevValue) => {
      if (inputName === "Type of Loan" && value === "Adjustable") {
        setTypeOfLoanValue(true);
        console.log("true valueee", value);
      } else if (value === "Fixed") {
        console.log("false valueee", value);
        setTypeOfLoanValue(false);
      }

      let updatedValue = { ...prevValue };
      // countAdditionalPrincipalPayments
      if (inputName === "Disbursement Dates") {
        // Check if inputName is Disbursement Dates
        console.log("heree in 0");
        console.log("updatedValue[inputName]", updatedValue[inputName]);
        if (!Array.isArray(updatedValue[inputName])) {
          // Initialize as an empty array if it's not already an array
          updatedValue[inputName] = [];
        }
        // Push an object with value into the array
        updatedValue[inputName].push(value);
      }
      if (
        inputName === "Extra Principal Payment Description" ||
        inputName === "Amount" ||
        inputName === "Frequency" ||
        inputName === "Extra Payment Start Date" ||
        inputName === "Number of Occurrences" ||
        inputName === "Extra Payment End Date"
      ) {
        // Check if inputName is payment
        if (!updatedValue[inputName]) {
          console.log(
            `Initializing ${inputName} as an array with value:`,
            value
          );
          // If payment doesn't exist, create an array and store the value at index 0
          updatedValue[inputName] = [value];
        } else {
          const index =
            countAdditionalPrincipalPayments - 1; /* specify your index */
          console.log(
            `Before updating, ${inputName} is:`,
            updatedValue[inputName]
          );

          // Ensure updatedValue[inputName] is an array before updating
          if (Array.isArray(updatedValue[inputName])) {
            updatedValue[inputName][index] = value; // Update value at a specific index
            console.log(
              `Updated ${inputName} at index ${index}:`,
              updatedValue[inputName]
            );
          } else {
            console.error(
              `${inputName} is not an array!`,
              updatedValue[inputName]
            );
          }
        }
      }
      if (
        inputName === "Adjustable Loan Details" ||
        inputName === "Date of Rate Change" ||
        inputName === "New Percent" ||
        inputName === "Monthly Payment Changes"
      ) {
        // Check if inputName is payment
        setAdjustableData({
          ...adjustableData,
          [inputName]: value,
        });
        // getAdjusabtles();

        // if (!updatedValue[inputName]) {
        //   // If payment doesn't exist, create an array and store the value at index 0
        //   updatedValue[inputName] = [value];
        // } else {
        //   // If payment exists, update the specific index or push the value to the array
        //   const index = countAdjustableLoanDetails - 1; /* specify your index */
        //   updatedValue[inputName][index] = value; // Update value at a specific index
        //   // Or you can push the value to the end of the array
        //   // updatedValue[inputName].push(value);
        // }
      } else {
        if (inputName !== "Disbursement Dates") {
          updatedValue[inputName] = value; // Store value normally for non-payment inputs
        }
      }

      return updatedValue;
    });
  }
  const getAdjusabtles = (newArray) => {
    if (newArray) {
      const result = newArray.reduce((accumulator, item) => {
        Object.keys(item).forEach((key) => {
          accumulator[key] = accumulator[key] || [];
          accumulator[key].push(item[key]);
        });
        return accumulator;
      }, {});

      console.log("resultresult", result);
      setPayloadAdjustable(result);
    } else {
      console.log("adjustableTable is not available yet");
    }
  };
  // function handleInputFields(inputName, value) {
  //   setPayload((prevValue) => {
  //     if (inputName === "Type of Loan" && value === "Adjustable") {
  //       setTypeOfLoanValue(true);
  //       console.log("true valueee", value);
  //     } else if (value === "Fixed") {
  //       console.log("false valueee", value);
  //       setTypeOfLoanValue(false);
  //     }

  //     let updatedValue = { ...prevValue };

  //     if (inputName === "Extra Principal Payment Description") {
  //       const index = countAdditionalPrincipalPayments - 1;

  //       // Check if the inputName already exists and if the index is valid
  //       if (!updatedValue[inputName]) {
  //         updatedValue[inputName] = []; // Initialize the array if it doesn't exist
  //       }

  //       if (index >= 0) {
  //         // Ensure the index is non-negative
  //         if (!updatedValue[inputName][index]) {
  //           updatedValue[inputName][index] = value; // Update value at a specific index
  //         } else {
  //           console.log(`Value at index ${index} already exists.`);
  //         }
  //       }
  //     } else {
  //       updatedValue[inputName] = value; // Store value normally for non-payment inputs
  //     }

  //     return updatedValue;
  //   });
  // }
  console.log("payload", payload);
  console.log("payload attributes", attributeValues);

  const DynamicComponentGenerator = (item) => {
    {
      // console.log("item in DynamicComponentGenerator", item);
      // console.log("data[item]....", data[item]);
      if (
        activeTabName === "ASSET INFORMATION" ||
        activeTabName === "ADDITIONAL INFORMATION"
      ) {
        // console.log("data[item] here", item);
        if (dataObject[item]) {
          if (dataObject[item]["formGroupName"]) {
            return <></>;
          } else {
            return SubFieldGenerator(dataObject[item]);
          }
        }
      } else {
        if (data[item]) {
          // console.log("in first if");
          if (data[item]["formGroupName"]) {
            return (
              <>
                {/* <Styles.SubFormDiv>
                <h1>here was a Group</h1>
              </Styles.SubFormDiv> */}
              </>
            );
          } else {
            // console.log(
            //   "in //second if::::data[item].dataType",
            //   data[item].dataType
            // );
            return SubFieldGenerator(data[item]);
          }
        }
      }
    }
  };
  const SubFieldGenerator = (item) => {
    // console.log("item in SubFieldGenerator", item);
    const { view } = useParams();

    switch (item.dataType) {
      case "boolean":
        return (
          <>
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
              }}
            >
              {console.log(
                "values[item.name]",
                values[item.name],
                attributeValues[item.name]
              )}
              <label style={{ display: "flex", flexDirection: "column" }}>
                {item.name}
                <Radio.Group
                  disabled={view}
                  style={{ marginTop: "0.5rem" }}
                  value={
                    values[item.name]
                      ? ((values[item.name] === true ||
                          values[item.name] === "true") &&
                          "true") ||
                        ((values[item.name] === false ||
                          values[item.name] === "false") &&
                          "false")
                      : ((values[item.name] === true ||
                          values[item.name] === "true") &&
                          "true") ||
                        ((values[item.name] === false ||
                          values[item.name] === "false") &&
                          "false")
                  }
                  size="large"
                  onChange={(e) => {
                    handleInputFields(item.name, e.target.value);
                    console.log("radio value", e.target.value);
                    values[item.name] = e.target.value;
                  }}
                >
                  <Radio.Button value="true">Yes</Radio.Button>
                  <Radio.Button value="false">No</Radio.Button>
                </Radio.Group>
              </label>
            </Styles.SubFormDiv>
            {title && title === "PAYMENTS" && (
              <div
                style={{
                  paddingInline: "3rem",
                  fontSize: "14px",
                  color: "black",
                }}
              >
                {title && title === "PAYMENTS" && (
                  <React.Fragment>
                    <Styles.SubFormDiv
                      style={{
                        marginTop: "0.5rem",
                      }}
                    >
                      <label
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        Additional Principal Payment?
                        <Radio.Group
                          disabled={view}
                          style={{ marginTop: "0.5rem" }}
                          name="Additional Principal Payment?"
                          size="large"
                          onChange={(e) => {
                            handleInputFields(e.target.name, e.target.value);
                            console.log(
                              "radio value",
                              e.target.name,
                              e.target.value
                            );
                            if (e.target.value === "false") {
                              // handleSubmit();
                            }
                            values[e.target.name] = e.target.value;
                          }}
                        >
                          <Radio.Button value="true">Yes</Radio.Button>
                          <Radio.Button value="false">No</Radio.Button>
                        </Radio.Group>
                      </label>
                    </Styles.SubFormDiv>
                  </React.Fragment>
                )}
              </div>
            )}
          </>
        );

        break;
      case "string":
        return (
          <>
            {item.name === "Name" ? (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label
                  style={
                    {
                      // marginTop: "20px",
                    }
                  }
                >
                  {item.name}
                </label>
                <Styles.InputBorder>
                  <input
                    readOnly={view}
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      width: "98%",
                      // marginTop:"0.5rem"
                    }}
                    onChange={(e) => {
                      handleInputFields(item.name, [e.target.value]);
                      if (attributeValues[item.name]) {
                        attributeValues[item.name] = e.target.value;
                      }
                    }}
                    value={
                      payload[item.name]
                        ? payload[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                  />
                </Styles.InputBorder>
              </Styles.SubFormDiv>
            ) : (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label
                  style={
                    {
                      // marginTop: "20px",
                    }
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      columnGap: "3px",
                    }}
                  >
                    <div>
                      {item.name === "Nickname of Liabilities"
                        ? "Name of Liability"
                        : item.name}{" "}
                      {[
                        "Credit Limit",
                        "Nickname of Credit",
                        "Credit Balance",
                        "Interest Rate (or APR%)",
                        "Nickname of Liabilities",
                        "Initial Loan Amount",
                        "Start Date",
                        "Maturity Date",
                        "Interest Rate",
                      ].includes(item.name) && (
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      )}
                      {/* {module === "Credit Card - Business" && ["Credit Limit", "Nickname of Credit", "Credit Balance", "Interest Rate (or APR%)"].includes(item.name) && (
                    <span style={{ color: "red", fontSize: "20px" }}>*</span>
                  )} */}
                    </div>
                    {/* {item.name === "Nickname of Liabilities"
                    ? "Name of Liability"
                    : item.name} */}
                    {item &&
                      item.name &&
                      [
                        "Nickname of Liabilities",
                        "Owner",
                        "Account Number",
                        "Name of Financial Institution",
                      ].includes(item.name) && (
                        <ToolTipCreator
                          name={
                            item.name === "Nickname of Liabilities"
                              ? "Liabilities_Name_of_Liability"
                              : item.name === "Owner"
                              ? "Liabilities_Owner"
                              : item.name === "Account Number"
                              ? "Liabilities_Account_Number"
                              : item.name === "Name of Financial Institution"
                              ? "Liabilities_Name_of_Financial_Institution"
                              : ""
                          }
                        />
                      )}
                  </div>
                </label>
                {item.name === "Owner" ? (
                  <div style={{ width: "94%" }}>
                    <AutoComplete
                      className="custom-auto-select"
                      placeholder="Select Owner"
                      value={
                        payload && payload[item.name]
                          ? payload[item.name]
                          : attributeValues[item.name]
                          ? attributeValues[item.name]
                          : ""
                      }
                      // When user types
                      onSearch={(text) => {
                        handleInputFields(item.name, text);
                      }}
                      // When user selects an option
                      onSelect={(value, option) => {
                        if (value === "__add_new_owner__") {
                          setIsModalOpen(true);
                        } else {
                          handleInputFields(item.name, value);
                        }
                      }}
                      optionLabelProp="value"
                      dataSource={[
                        ...ownerList.map((owner, idx) => (
                          <Options key={idx} value={owner.Name}>
                            {owner.Name} {owner.Type ? `(${owner.Type})` : ""}
                          </Options>
                        )),
                        <Options value="__add_new_owner__" key="add_new_owner">
                          + Add New Owner
                        </Options>,
                      ]}
                    >
                      <Input className="custom-auto-select-input" />
                    </AutoComplete>
                    {isModalOpen && (
                      <AddOwnerModal
                        title={"Add Owner Details"}
                        open={isModalOpen}
                        handleChange={handleChangeOwner}
                        handleCancel={handleCancel}
                        data={formDataOwner && formDataOwner}
                        handleSave={handleSave}
                      />
                    )}
                  </div>
                ) : (
                  <Styles.InputBorder>
                    <input
                      readOnly={view}
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        width: "98%",
                        // marginTop:"0.5rem"
                      }}
                      onChange={(e) => {
                        // const owner = new Array(item.name);
                        // console.log("item.name[countAdjustableLoanDetails]",owner,countAdjustableLoanDetails, e.target.value,);
                        handleInputFields(item.name, e.target.value);
                        if (
                          item.name === "Extra Principal Payment Description"
                        ) {
                          if (attributeValues[item.name]) {
                            const index = countAdditionalPrincipalPayments - 1;
                            attributeValues[item.name][index] = e.target.value;
                          }
                        }
                        if (item.name === "Adjustable Loan Details") {
                          if (attributeValues[item.name]) {
                            const index = countAdjustableLoanDetails - 1;
                            attributeValues[item.name][index] = e.target.value;
                            // console.log("attributeValues[item.name][index]",attributeValues[item.name][index],e.target.value)
                          }
                        }
                        if (attributeValues[item.name]) {
                          attributeValues[item.name] = e.target.value;
                        }
                      }}
                      value={
                        (item.name === "Extra Principal Payment Description" ||
                          item.name === "Adjustable Loan Details") &&
                        module
                          ? item.name === "Adjustable Loan Details"
                            ? adjustableData &&
                              adjustableData["Adjustable Loan Details"]
                            : ""
                            ? adjustableData["Adjustable Loan Details"]
                            : attributeValues[item.name] &&
                              attributeValues[item.name][0]
                          : payload[item.name]
                          ? payload[item.name]
                          : attributeValues[item.name]
                          ? attributeValues[item.name]
                          : ""
                      }
                      // value={
                      //   item.name === "Extra Principal Payment Description"
                      //     ?  payload[item.name]
                      //       ? payload[item.name][countAdditionalPrincipalPayments] // Replace specificIndex with your desired index
                      //       : attributeValues[item.name]
                      //     : payload[item.name]
                      //       ? payload[item.name]
                      //       : attributeValues[item.name]
                      //         ? attributeValues[item.name]
                      //         : ""
                      // }
                      // value={
                      //   payload[item.name]
                      //     ? payload[item.name]
                      //     : attributeValues[item.name]
                      //     ? attributeValues[item.name]
                      //     : ""
                      // }
                    />
                  </Styles.InputBorder>
                )}
              </Styles.SubFormDiv>
            )}
          </>
        );

        break;
      case "int":
        return (
          <>
            {item.name === "Percent" ||
            item.name === "Credit Limit" ||
            item.name === "Credit Balance" ||
            item.name === "Monthly Payment" ||
            item.name === "Initial Loan Amount" ||
            item.name === "Total Credit Available" ||
            item.name === "Loan Balance" ||
            item.name === "Annual Fee" ||
            item.name === "Amount" ? (
              <>
                {item.name === "Percent" ? (
                  <Styles.SubFormDiv
                    style={{
                      marginTop: "0.5rem",
                    }}
                  >
                    <label>{item.name}</label>
                    <Styles.InputBorder>
                      <input
                        readOnly={view}
                        // type="number"
                        // pattern="[0-9]*"
                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                        style={{
                          outline: "none",
                          border: "none",
                          width: "98%",
                        }}
                        onChange={(e) => {
                          const result = e.target.value.replace(/\D/g, "");
                          handleInputFields(item.name, [result]);
                        }}
                        value={
                          payload[item.name]
                            ? payload[item.name]
                            : attributeValues[item.name]
                            ? attributeValues[item.name]
                            : ""
                        }
                      />
                    </Styles.InputBorder>
                  </Styles.SubFormDiv>
                ) : (
                  <Styles.SubFormDiv
                    style={{
                      marginTop: "0.5rem",
                    }}
                  >
                    <label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          columnGap: "3px",
                        }}
                      >
                        {/* {item.name} */}
                        <div>
                          {item.name}{" "}
                          {["Initial Loan Amount", "Credit Limit"].includes(
                            item.name
                          ) && (
                            <span style={{ color: "red", fontSize: "20px" }}>
                              *
                            </span>
                          )}
                        </div>
                        {item &&
                          item.name &&
                          ["Initial Loan Amount"].includes(item.name) && (
                            <ToolTipCreator
                              name={
                                item.name === "Initial Loan Amount"
                                  ? "Liabilities_Intial_Loan_Amount"
                                  : ""
                              }
                            />
                          )}
                      </div>
                    </label>

                    <Styles.InputBorder
                      style={{
                        paddingLeft:
                          item.name !== "Percent" || item.name === "Account"
                            ? "0"
                            : "1rem",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "20px",
                          padding: "8px",
                          display: "flex",
                          alignItems: "center",
                          color: "rgba(0, 0, 0, 0.65)",
                          background: "#fafafa",
                          borderTopLeftRadius: "8px",
                          borderBottomLeftRadius: "8px",
                          borderRight: "1px solid #d9d9d9",
                        }}
                      >
                        $
                      </span>
                      <InputNumber
                        style={{
                          outline: "none",
                          border: "none",
                          width: "92%",
                          height: "3.5rem",
                        }}
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                        onChange={(value) => {
                          handleInputFields(item.name, value);
                          if (item.name === "Amount") {
                            if (attributeValues[item.name]) {
                              const index =
                                countAdditionalPrincipalPayments - 1;
                              attributeValues[item.name][index] = value;
                            }
                          } else {
                            if (attributeValues[item.name]) {
                              attributeValues[item.name] = value;
                            }
                          }
                        }}
                        value={
                          item.name === "Amount" && module
                            ? (attributeValues[item.name] &&
                                attributeValues[item.name][0]) ||
                              (payload[item.name] &&
                                payload[item.name][0] &&
                                payload[item.name][0])
                            : payload[item.name]
                            ? payload[item.name]
                            : attributeValues[item.name]
                            ? attributeValues[item.name]
                            : ""
                        }
                      />
                    </Styles.InputBorder>
                  </Styles.SubFormDiv>
                )}
              </>
            ) : item.name === "Length of Loan (No of years remaining)" ? (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label>{item.name}</label>
                <Styles.InputBorder>
                  <input
                    readOnly={view}
                    // type="number"
                    // pattern="[0-9]*"
                    disabled={true}
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                    style={{
                      outline: "none",
                      border: "none",
                      width: "98%",
                    }}
                    onChange={(e) => {
                      const result = e.target.value.replace(/\D/g, "");
                      handleInputFields(item.name, result);
                    }}
                    value={
                      payload[item.name]
                        ? payload[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                  />
                </Styles.InputBorder>
              </Styles.SubFormDiv>
            ) : (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label>{item.name}</label>
                <Styles.InputBorder>
                  <input
                    readOnly={view}
                    // type="number"
                    // pattern="[0-9]*"
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                    style={{
                      outline: "none",
                      border: "none",
                      width: "98%",
                    }}
                    onChange={(e) => {
                      const result = e.target.value.replace(/\D/g, "");
                      if (item.name === "Initial Loan Amount") {
                        handleInputFields(item.name, result);
                      } else {
                        handleInputFields(item.name, result);
                      }
                      if (item.name === "Number of Occurrences") {
                        if (attributeValues[item.name]) {
                          const index = countAdditionalPrincipalPayments - 1;
                          attributeValues[item.name][index] = result;
                        }
                      }
                      if (
                        item.name === "New Percent" ||
                        item.name === "Monthly Payment Changes"
                      ) {
                        if (attributeValues[item.name]) {
                          const index = countAdjustableLoanDetails - 1;
                          attributeValues[item.name][index] = e.target.value;
                        }
                      } else {
                        if (attributeValues[item.name]) {
                          attributeValues[item.name] = e.target.value;
                        }
                      }
                    }}
                    value={
                      (item.name === "Number of Occurrences" ||
                        item.name === "New Percent" ||
                        item.name === "Monthly Payment Changes") &&
                      module
                        ? item.name === "New Percent" &&
                          adjustableData &&
                          adjustableData["New Percent"]
                          ? adjustableData["New Percent"]
                          : item.name === "Monthly Payment Changes" &&
                            adjustableData &&
                            adjustableData["Monthly Payment Changes"]
                          ? adjustableData["Monthly Payment Changes"]
                          : attributeValues[item.name] &&
                            attributeValues[item.name][0]
                        : payload[item.name]
                        ? payload[item.name] ||
                          (payload[item.name] && payload[item.name][0])
                        : attributeValues[item.name]
                        ? attributeValues[item.name] ||
                          attributeValues[item.name][0]
                        : ""
                    }
                    // value={
                    //   (item.name === "Number of Occurrences" ||
                    //     item.name === "New Percent" ||
                    //     item.name === "Monthly Payment Changes") &&
                    //     module
                    //     ? (item.name === "New Percent" ||
                    //         item.name === "Monthly Payment Changes" || item.name !== "Number of Occurrences" ) &&
                    //       adjustableData &&
                    //       adjustableData[item.name]
                    //       ? adjustableData[item.name]
                    //       : ""
                    //     : attributeValues[item.name] &&
                    //       attributeValues[item.name][0]
                    //     ? attributeValues[item.name][0] || payload[item.name] && payload[item.name][0]
                    //     : payload[item.name]
                    //     ? payload[item.name] || payload[item.name] &&  payload[item.name][0]
                    //     : attributeValues[item.name]
                    //     ? attributeValues[item.name]
                    //     : ""
                    // }
                  />
                </Styles.InputBorder>
              </Styles.SubFormDiv>
            )}
          </>
        );

      case "float":
        return (
          <>
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
              }}
            >
              <label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  {/* {item.name} */}
                  <div>
                    {item.name}{" "}
                    {[
                      "Interest Rate",
                      "Credit Balance",
                      "Credit Limit",
                      "Interest Rate (or APR%)",
                    ].includes(item.name) && (
                      <span style={{ color: "red", fontSize: "20px" }}>*</span>
                    )}
                  </div>
                  {item &&
                    item.name &&
                    ["Interest Rate", "Loan Balance"].includes(item.name) && (
                      <ToolTipCreator
                        name={
                          item.name === "Interest Rate"
                            ? "Liabilities_Interest_Rate"
                            : item.name === "Loan Balance"
                            ? "Liabilities_Loan_Balance"
                            : ""
                        }
                      />
                    )}
                </div>
              </label>
              <Styles.InputBorder>
                <input
                  readOnly={view}
                  // type="number"
                  // pattern="[0-9]*"
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}(?:\.\d{0,2})?"
                  style={{
                    outline: "none",
                    border: "none",
                    width: "98%",
                  }}
                  onChange={(e) => {
                    const result = e.target.value.replace(
                      /^(-?\D+(\.\D{0,2})?)$/,
                      ""
                    );
                    // console.log("result",result);
                    const re = /^\d*(?:\.\d{0,2})?$/;
                    if (e.target.value === "" || re.test(e.target.value)) {
                      handleInputFields(item.name, result);
                    }
                    if (attributeValues[item.name]) {
                      attributeValues[item.name] = result;
                    }
                  }}
                  value={
                    payload[item.name]
                      ? payload[item.name]
                      : attributeValues[item.name]
                      ? attributeValues[item.name]
                      : ""
                  }
                />
                {(item.name === "Interest Rate" ||
                  item.name === "Interest Rate (or APR%)") && (
                  <span
                    style={{
                      fontSize: "20px",
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      color: "rgba(0, 0, 0, 0.65)",
                      background: "#fafafa",
                      borderTopRightRadius: "8px",
                      borderBottomRightRadius: "8px",
                      borderLeft: "1px solid #d9d9d9",
                    }}
                  >
                    %
                  </span>
                )}
              </Styles.InputBorder>
            </Styles.SubFormDiv>
          </>
        );
      case "Formula":
        return (
          <>
            {item.name === "Monthly Payment" ? (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      columnGap: "3px",
                    }}
                  >
                    {item.name}
                    {item &&
                      item.name &&
                      ["Monthly Payment"].includes(item.name) && (
                        <ToolTipCreator
                          name={
                            item.name === "Monthly Payment"
                              ? "Liabilities_Monthly_Payment"
                              : ""
                          }
                        />
                      )}
                  </div>
                </label>
                <Styles.InputBorder
                  style={{
                    paddingLeft:
                      item.name !== "Percent" || item.name === "Account"
                        ? "0"
                        : "1rem",
                    cursor:
                      item.name === "Monthly Payment"
                        ? "not-allowed"
                        : "Pointer",
                    opacity: item.name === "Monthly Payment" ? "0.6" : "1",
                  }}
                >
                  <CurrencyCosts
                    readOnly={view || item.name === "Monthly Payment"}
                    value={
                      payload[item.name] && payload[item.name] != 0
                        ? payload[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                    onChange={(e) => {
                      const result = e.target.value.replace(/\D/g, "");
                      handleInputFields(item.name, result);
                    }}
                  />
                </Styles.InputBorder>
              </Styles.SubFormDiv>
            ) : (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      columnGap: "3px",
                    }}
                  >
                    {item.name}
                    {item &&
                      item.name &&
                      ["Length of Loan (No of years remaining)"].includes(
                        item.name
                      ) && (
                        <ToolTipCreator
                          name={
                            item.name ===
                            "Length of Loan (No of years remaining)"
                              ? "Liabilities_Length_of_Loan"
                              : ""
                          }
                        />
                      )}
                  </div>
                </label>
                <Styles.InputBorder>
                  <input
                    readOnly={view}
                    // type="number"
                    // pattern="[0-9]*"
                    disabled={true}
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                    style={{
                      outline: "none",
                      border: "none",
                      width: "98%",
                    }}
                    onChange={(e) => {
                      const result = e.target.value.replace(/\D/g, "");
                      handleInputFields(item.name, result);
                    }}
                    value={
                      payload[item.name] && payload[item.name] != 0
                        ? payload[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                  />
                </Styles.InputBorder>
              </Styles.SubFormDiv>
            )}
          </>
        );

        break;
      case "dropdown":
        {
          console.log(
            "dropdown itemaa",
            // item.attribute_default_values[0].value === "Adjustable"
            // item.name,
            item.name === "Type of Loan"
            // payload["Adjustable"] === "true"
          );
        }
        return (
          <>
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
              }}
            >
              <label>{item.name}</label>
              <div style={{ width: "94%" }}>
                <DropDown
                  readOnly={view}
                  style={defaultStyles.styles.dropDown.m_smallDropdown1}
                  listingStyle={{
                    ...defaultStyles.styles.dropDown.m_smallDropdown2,
                    height: "auto",
                  }}
                  name={item.name}
                  title={item.name}
                  list={item.attribute_default_values}
                  displayKey="value"
                  disableSearch={false}
                  setSelectedItem={({ name, value }) => {
                    handleInputFields(name, value);
                    // if (attributeValues[item.name]) {
                    //   attributeValues[item.name][0] = value;
                    // }
                  }}
                  defaultValue={
                    item.name === "Frequency" && module
                      ? attributeValues[item.name] &&
                        attributeValues[item.name][0]
                      : values && values[item.name]
                      ? values[item.name]
                      : attributeValues[item.name]
                      ? attributeValues[item.name]
                      : ""
                  }
                />
              </div>
            </Styles.SubFormDiv>
          </>
        );

        break;
      case "date":
        return (
          <>
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
              }}
            >
              <label
                style={
                  {
                    // display: "flex", flexDirection: "column"
                  }
                }
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  {/* {item.name} */}
                  <div>
                    {item.name}{" "}
                    {["Maturity Date", "Start Date"].includes(item.name) && (
                      <span style={{ color: "red", fontSize: "20px" }}>*</span>
                    )}
                  </div>
                  {item &&
                    item.name &&
                    [
                      "Start Date",
                      "Maturity Date",
                      "Monthly Payment Due",
                    ].includes(item.name) && (
                      <ToolTipCreator
                        name={
                          item.name === "Start Date"
                            ? "Liabilities_Start_Date"
                            : item.name === "Maturity Date"
                            ? "Liabilities_Maturity_Date"
                            : item.name === "Monthly Payment Due"
                            ? "Liabilities_Monthly_Payment_Due"
                            : ""
                        }
                      />
                    )}
                </div>
              </label>
              <Styles.InputBorder
                style={{
                  display: "flex",
                  alignItems: "center",
                  overflow: "hidden",
                }}
              >
                {item.name === "Disbursement Dates" ? (
                  <DatePicker
                    disabled={view}
                    // className="ant-calendar-picker-input ant-input"
                    format={"MM/DD/YYYY"}
                    style={{
                      outline: "none",
                      border: "none",
                      borderRadius: "0.5rem",
                    }}
                    placeholder="Select Date"
                    onChange={(e) => {
                      if (e !== null) {
                        handleInputFields(item.name, e.toString());
                      }
                    }}
                    value={
                      item.name === "Disbursement Dates" && module
                        ? attributeValues[item.name] &&
                          moment(attributeValues[item.name][0] || new Date())
                        : values[item.name]
                        ? moment(values[item.name])
                        : moment(payload[item.name] || new Date())
                    }
                  />
                ) : (
                  <DatePicker
                    disabled={view}
                    // className="ant-calendar-picker-input ant-input"
                    format={"MM/DD/YYYY"}
                    style={{
                      outline: "none",
                      border: "none",
                      // width: "20rem",
                      // marginTop: "0.4rem",
                      borderRadius: "0.5rem",
                    }}
                    placeholder="Select Purchase Date"
                    onChange={(e) => {
                      if (e !== null) {
                        handleInputFields(item.name, e.toString());
                        values[item.name] = e.toString();
                        //                       if(attributeValues[item.name] && attributeValues[item.name][0]){
                        // console.log("attributeValues[item.name]",attributeValues[item.name][0],"values",values[item.name][0])
                        //                         // attributeValues[item.name][0]=e.toString();
                        //                         }
                      }
                    }}
                    value={
                      (item.name === "Extra Payment End Date" ||
                        item.name === "Extra Payment Start Date" ||
                        item.name === "Date of Rate Change") &&
                      module
                        ? attributeValues[item.name] &&
                          moment(
                            attributeValues[item.name] ||
                              attributeValues[item.name][0] ||
                              new Date()
                          )
                        : values[item.name]
                        ? moment(values[item.name])
                        : moment(payload[item.name] || new Date())
                    }
                    // defaultValue={
                    //   values[item.name]
                    //     ? moment(values[item.name])
                    //     : moment(payload[item.name] || new Date())
                    // }
                  />
                )}
              </Styles.InputBorder>
            </Styles.SubFormDiv>
          </>
        );

        break;

      default:
        console.error("invalid DataType Detected :::: ", item.dataType);
        // return <h1>invalid DataType Detected :::: {item.dataTyp  e}</h1>;
        break;
    }
  };
  const { module } = useParams();

  const groupedFieldsPage = (fieldss) => {
    console.log("fieldss", fieldss);
    if (additionalPrincipalPayments) {
      let temp = Object.values(fieldss)[0];
      console.log("temppppp", temp);
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("Object.values(fieldss)", temmp);
      return temmp;
    }
    if (disbursementDate) {
      let temp = Object.values(fieldss)[1];
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      return temmp;
    }
    if (adjustableLoanDetails) {
      let temp = Object.values(fieldss)[1];
      console.log("temppppp", temp);
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("Object.values(fieldss)", temmp);
      return temmp;
    }
    if (additionalLoanInformation) {
      let temp = Object.values(fieldss)[4];
      console.log("temppppp", temp);
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("Object.values(fieldss)", temmp);
      return temmp;
    }
    if (additionalCreditCardInformation) {
      let temp = Object.values(fieldss)[4];
      console.log("temppppp", temp);
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("Object.values(fieldss)", temmp);
      return temmp;
    }
  };

  const { view } = useParams();

  const [
    newObjectAdditionalPrincipalPayments,
    setObjectAdditionalPrincipalPayments,
  ] = useState({});
  const [
    countAdditionalPrincipalPayments,
    setCountAdditionalPrincipalPayments,
  ] = useState(1);
  const [collapseObjects, setCollapseObjects] = useState([]);

  const handleNewAdditionalPrincipalPayments = () => {
    setObjectAdditionalPrincipalPayments(additionalPrincipalPayments);
    setCollapseObjects((prevObjects) => [
      ...prevObjects,
      newObjectAdditionalPrincipalPayments,
    ]);
    setCountAdditionalPrincipalPayments(countAdditionalPrincipalPayments + 1);
  };
  const [newObjectDisbursementDate, setNewObjectDisbursementDate] = useState(
    {}
  );
  const [countDisbursementDate, setCountDisbursementDate] = useState(1);
  const [collapseObjectsDisbursementDate, setCollapseObjectsDisbursementDate] =
    useState([]);

  const handleAddNewDate = () => {
    setNewObjectDisbursementDate(disbursementDate);
    setCollapseObjectsDisbursementDate((prevObjects) => [
      ...prevObjects,
      newObjectDisbursementDate,
    ]);
    setCountDisbursementDate(countDisbursementDate + 1);
  };
  //
  //
  //

  const [newObjectadjustableLoanDetails, setNewObjectAdjustableLoanDetails] =
    useState({});
  const [countAdjustableLoanDetails, setCountAdjustableLoanDetails] =
    useState(1);
  const [
    collapseObjectsAdjustableLoanDetails,
    setCollapseObjectsAdjustableLoanDetails,
  ] = useState([]);

  const handleAdjustableLoanDetails = () => {
    console.log("adjustableData", adjustableData);
    let newArray = [...adjustableTable];

    let obj = {
      loanAmount: adjustableData && adjustableData["Adjustable Loan Details"],
      dateofChange: adjustableData && adjustableData["Date of Rate Change"],
      newPercent: adjustableData && adjustableData["New Percent"],
      monthlyChanges:
        adjustableData && adjustableData["Monthly Payment Changes"],
    };

    newArray.push(obj);
    console.log("newArray", newArray);
    let objNew = {};
    if (payload) {
      objNew = { ...attributeValues };
    }
    if (attributeValues) {
      objNew = { ...attributeValues };
    }
    console.log("objNew", objNew, obj);
    if (obj) {
      objNew["Adjustable Loan Details"] = obj.loanAmount || "";
      objNew["Date of Rate Change"] = obj.dateofChange || "";
      objNew["New Percent"] = obj.newPercent || "";
      objNew["Monthly Payment Changes"] = obj.monthlyChanges || "";
    }
    console.log("objjjjjjj inside", objNew);
    // setSubmitBody(objNew);

    setAdjustableTable(newArray);
    getAdjusabtles(newArray);
    setAdjustableData(null);
    setAdjustableData({
      "Adjustable Loan Details": "",
      "Date of Rate Change": new Date(),
      "New Percent": "",
      "Monthly Payment Changes": "",
    });
    setCountAdjustableLoanDetails(countAdjustableLoanDetails + 1);
  };
  console.log("adjustableTable", adjustableTable);

  return (
    <>
      <div style={{ margin: " 0 3rem" }}>
        <div
          style={{
            fontFamily: "Poppins",
            fontSize: "24px",
            fontWeight: "500",
            color: "#030229",
            textAlign: "center",
            marginBottom: "8px",
          }}
        >
          {module === "Real Estates" ? "Real Estate" : module}
        </div>
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h1
            style={{
              fontFamily: "Poppins",
              fontSize: "20px",
              fontWeight: "500",
              color: "#030229",
            }}
          >
            {(title &&
              title === "ADDITIONAL INFORMATION" &&
              "AMOUNTS AND PAYMENTS") ||
              (title && title === "LOAN" && "LOAN PAYBACK TYPE") ||
              (title &&
                title === "ADJUSTABLE LOAN" &&
                "ADJUSTABLE LOAN DETAILS") ||
              (title && title === "PAYMENTS" && "ADDITIONAL PAYMENT DETAILS") ||
              title}
          </h1>
          <h1
            style={{
              fontFamily: "Poppins",
              fontSize: "16px",
              fontWeight: "500",
              color: "grey",
            }}
          >
            {view ? "(Read Only)" : ""}
          </h1>
        </div>
      </div>
      <div style={{ paddingInline: "3rem", fontSize: "14px", color: "black" }}>
        {title && title === "PAYMENTS" && (
          <React.Fragment>
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
              }}
            >
              <label
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                Additional Principal Payment?
                <Radio.Group
                  disabled={view}
                  style={{ marginTop: "0.5rem" }}
                  name="Additional Principal Payment?"
                  size="large"
                  onChange={(e) => {
                    handleInputFields(e.target.name, e.target.value);
                    console.log("radio value", e.target.name, e.target.value);
                    if (e.target.value === "false") {
                      // handleSubmit();
                    }
                    values[e.target.name] = e.target.value;
                  }}
                >
                  <Radio.Button value="true">Yes</Radio.Button>
                  <Radio.Button value="false">No</Radio.Button>
                </Radio.Group>
              </label>
            </Styles.SubFormDiv>
          </React.Fragment>
        )}
      </div>
      <Styles.FormDiv>
        {activeTabName === "ASSET INFORMATION" &&
          orderOfNamesInfoRealEstate &&
          orderOfNamesInfoRealEstate.map((item, indx) => {
            return DynamicComponentGenerator(item);
          })}
        {activeTabName === "ADDITIONAL INFORMATION" &&
          orderOfNamesPayment &&
          orderOfNamesPayment.map((item, indx) => {
            return DynamicComponentGenerator(item);
          })}
        {inputFields.map((item, indx) => {
          return DynamicComponentGenerator(item);
        })}
      </Styles.FormDiv>

      <div>
        {groupedFieldsPage(disbursementDate) == activeTabName &&
          Object.keys(disbursementDate).map((grpField, index) => {
            const groupedFieldsItemKeys = Object.keys(
              disbursementDate[grpField]
            );
            groupedFieldsItemKeys.map((ItemKey) => {
              switch (disbursementDate[grpField][ItemKey]["subType"]) {
                case "array":
                  return (
                    <React.Fragment>
                      <h1>array type Detected</h1>
                    </React.Fragment>
                  );
                  break;
                case "single":
                  // console.log("type singleeeeeeeee");

                  return (
                    <React.Fragment>
                      <h1>single type Detected</h1>
                    </React.Fragment>
                  );
                  break;

                default:
                  return <h1>default type Detected</h1>;
                  break;
              }
            });

            return (
              <React.Fragment>
                <h1
                  style={{
                    margin: " 2rem  3rem",
                    fontFamily: "Poppins",
                    fontSize: "20px",
                    fontWeight: "500",
                    color: "#030229",
                  }}
                >
                  {Object.keys(disbursementDate)[index]}
                </h1>
                <div style={{ margin: " 0 3rem", width: "50rem" }}>
                  <Collapse>
                    <Panel header={Object.keys(disbursementDate)[index]}>
                      {groupedFieldsItemKeys.map((ItemKey) => {
                        switch (
                          disbursementDate[grpField][ItemKey]["subType"]
                        ) {
                          case "array":
                            return SubFieldGenerator(
                              disbursementDate[grpField][ItemKey]
                            );

                            break;
                          case "single":
                            return SubFieldGenerator(
                              disbursementDate[grpField][ItemKey]
                            );
                            break;

                          default:
                            return <h1>default type Detected</h1>;
                            break;
                        }
                      })}
                    </Panel>
                  </Collapse>
                </div>

                {activeTabName === "ADDITIONAL INFORMATION" && (
                  <React.Fragment>
                    {collapseObjectsDisbursementDate.map((obj, index) => (
                      <div style={{ margin: " 0.5rem 3rem", width: "50rem" }}>
                        <Collapse>
                          <Panel
                            header={
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <span>{`Disbursment Dates ${index + 1}`}</span>
                                <div
                                  style={{
                                    outline: "none",
                                    border: "none",
                                    backgroundColor: "red",
                                    padding: "6px 12px",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    color: "white",
                                  }}
                                  onClick={() =>
                                    setCollapseObjectsDisbursementDate(
                                      (prevObjects) =>
                                        prevObjects.filter(
                                          (_, i) => i !== index
                                        )
                                    )
                                  }
                                >
                                  Remove
                                </div>
                              </div>
                            }
                          >
                            {groupedFieldsItemKeys.map((ItemKey) => {
                              switch (
                                disbursementDate[grpField][ItemKey]["subType"]
                              ) {
                                case "array":
                                  return SubFieldGenerator(
                                    disbursementDate[grpField][ItemKey]
                                  );

                                  break;
                                case "single":
                                  return SubFieldGenerator(
                                    disbursementDate[grpField][ItemKey]
                                  );
                                  break;

                                default:
                                  return <h1>default type Detected</h1>;
                                  break;
                              }
                            })}
                          </Panel>
                        </Collapse>
                      </div>
                    ))}
                  </React.Fragment>
                )}
                {activeTabName === "ADDITIONAL INFORMATION" &&
                disbursementDate ? (
                  <div style={{ width: "100%", display: "flex" }}>
                    <div
                      onClick={handleAddNewDate}
                      style={{
                        backgroundColor: "#2A3DA3",
                        padding: "10px 20px",
                        borderRadius: "10px",
                        float: "left",
                        margin: "1% 3rem",
                        cursor: "pointer",
                        color: "white",
                      }}
                    >
                      Add +
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </React.Fragment>
            );
          })}
      </div>

      {(payload["Additional Principal Payment?"] === "true" ||
        attributeValues["Extra Principal Payment Description"]) && (
        <div>
          {groupedFieldsPage(additionalPrincipalPayments) == activeTabName &&
            Object.keys(additionalPrincipalPayments).map((grpField, index) => {
              const groupedFieldsItemKeys = Object.keys(
                additionalPrincipalPayments[grpField]
              );
              groupedFieldsItemKeys.map((ItemKey) => {
                switch (
                  additionalPrincipalPayments[grpField][ItemKey]["subType"]
                ) {
                  case "array":
                    // console.log("type arayyyyyyyyyyyyyyyy");
                    return (
                      <React.Fragment>
                        <h1>array type Detected</h1>
                      </React.Fragment>
                    );
                    break;
                  case "single":
                    // console.log("type singleeeeeeeee");

                    return (
                      <React.Fragment>
                        <h1>single type Detected</h1>
                      </React.Fragment>
                    );
                    break;

                  default:
                    return <h1>default type Detected</h1>;
                    break;
                }
              });

              return (
                <>
                  <h1
                    style={{
                      margin: " 2rem  3rem",
                      fontFamily: "Poppins",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#030229",
                    }}
                  >
                    {Object.keys(additionalPrincipalPayments)[index]}
                  </h1>
                  <div style={{ margin: " 0 3rem", width: "50rem" }}>
                    <Collapse>
                      <Panel
                        header={Object.keys(additionalPrincipalPayments)[index]}
                      >
                        {groupedFieldsItemKeys.map((ItemKey) => {
                          switch (
                            additionalPrincipalPayments[grpField][ItemKey][
                              "subType"
                            ]
                          ) {
                            case "array":
                              return SubFieldGenerator(
                                additionalPrincipalPayments[grpField][ItemKey]
                              );

                              break;
                            case "single":
                              return SubFieldGenerator(
                                additionalPrincipalPayments[grpField][ItemKey]
                              );
                              break;

                            default:
                              return <h1>default type Detected</h1>;
                              break;
                          }
                        })}
                      </Panel>
                    </Collapse>
                  </div>

                  {activeTabName === "PAYMENTS" && (
                    <>
                      {collapseObjects.map((obj, index) => (
                        <div style={{ margin: " 0.5rem 3rem", width: "50rem" }}>
                          <Collapse>
                            <Panel
                              header={
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <span>{`Additional Principal Payments ${
                                    index + 1
                                  }`}</span>
                                  <div
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      backgroundColor: "red",
                                      padding: "6px 12px",
                                      borderRadius: "10px",
                                      cursor: "pointer",
                                      color: "white",
                                    }}
                                    onClick={() =>
                                      setCollapseObjects((prevObjects) =>
                                        prevObjects.filter(
                                          (_, i) => i !== index
                                        )
                                      )
                                    }
                                  >
                                    Remove
                                  </div>
                                </div>
                              }
                            >
                              {groupedFieldsItemKeys.map((ItemKey) => {
                                // console.log(
                                //   "groupedFields[grpField][ItemKey]",
                                //   groupedFields[grpField][ItemKey]
                                // );

                                // console.log(
                                //   "groupedFields[grpField][ItemKey][subType]",
                                //   groupedFields[grpField][ItemKey]["subType"]
                                // );
                                switch (
                                  additionalPrincipalPayments[grpField][
                                    ItemKey
                                  ]["subType"]
                                ) {
                                  case "array":
                                    return SubFieldGenerator(
                                      additionalPrincipalPayments[grpField][
                                        ItemKey
                                      ]
                                    );

                                    break;
                                  case "single":
                                    return SubFieldGenerator(
                                      additionalPrincipalPayments[grpField][
                                        ItemKey
                                      ]
                                    );
                                    break;

                                  default:
                                    return <h1>default type Detected</h1>;
                                    break;
                                }
                              })}
                            </Panel>
                          </Collapse>
                        </div>
                      ))}
                    </>
                  )}
                  {activeTabName === "PAYMENTS" &&
                  additionalPrincipalPayments ? (
                    <div
                      onClick={handleNewAdditionalPrincipalPayments}
                      style={{
                        backgroundColor: "#2A3DA3",
                        padding: "10px 20px",
                        borderRadius: "10px",
                        float: "left",
                        margin: "1% 3rem",
                        cursor: "pointer",
                        color: "white",
                      }}
                    >
                      Add +
                    </div>
                  ) : (
                    ""
                  )}
                </>
              );
            })}
        </div>
      )}

      {/*  */}
      {/*  */}
      {/*  */}
      <>
        {groupedFieldsPage(adjustableLoanDetails) == activeTabName &&
          adjustableTable && (
            <div style={{ paddingInline: "2rem" }}>
              <List cols={adjustableCols} rows={adjustableTable}></List>
            </div>
          )}
      </>
      <div>
        {groupedFieldsPage(adjustableLoanDetails) == activeTabName &&
          Object.keys(adjustableLoanDetails).map((grpField, index) => {
            const groupedFieldsItemKeys = Object.keys(
              adjustableLoanDetails[grpField]
            );
            groupedFieldsItemKeys.map((ItemKey) => {
              switch (adjustableLoanDetails[grpField][ItemKey]["subType"]) {
                case "array":
                  // console.log("type arayyyyyyyyyyyyyyyy");
                  return (
                    <>
                      <h1>array type Detected</h1>
                    </>
                  );
                  break;
                case "single":
                  // console.log("type singleeeeeeeee");

                  return (
                    <>
                      <h1>single type Detected</h1>
                    </>
                  );
                  break;

                default:
                  return <h1>default type Detected</h1>;
                  break;
              }
            });

            return (
              <>
                <h1
                  style={{
                    margin: " 2rem  3rem",
                    fontFamily: "Poppins",
                    fontSize: "20px",
                    fontWeight: "500",
                    color: "#030229",
                  }}
                >
                  {Object.keys(adjustableLoanDetails)[index]}
                </h1>
                <div style={{ margin: " 0 3rem", width: "50rem" }}>
                  <Collapse>
                    <Panel header={Object.keys(adjustableLoanDetails)[index]}>
                      {groupedFieldsItemKeys.map((ItemKey) => {
                        // console.log(
                        //   "groupedFields[grpField][ItemKey]",
                        //   groupedFields[grpField][ItemKey]
                        // );

                        // console.log(
                        //   "groupedFields[grpField][ItemKey][subType]",
                        //   groupedFields[grpField][ItemKey]["subType"]
                        // );
                        switch (
                          adjustableLoanDetails[grpField][ItemKey]["subType"]
                        ) {
                          case "array":
                            return SubFieldGenerator(
                              adjustableLoanDetails[grpField][ItemKey]
                            );

                            break;
                          case "single":
                            return SubFieldGenerator(
                              adjustableLoanDetails[grpField][ItemKey]
                            );
                            break;

                          default:
                            return <h1>default type Detected</h1>;
                            break;
                        }
                      })}
                    </Panel>
                  </Collapse>
                </div>

                {activeTabName === "ADJUSTABLE LOAN" && (
                  <>
                    {collapseObjectsAdjustableLoanDetails.map((obj, index) => (
                      <div style={{ margin: " 0.5rem 3rem", width: "50rem" }}>
                        <Collapse>
                          <Panel
                            header={
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <span>{`Adjustable Loan Details ${
                                  index + 1
                                }`}</span>
                                <div
                                  style={{
                                    outline: "none",
                                    border: "none",
                                    backgroundColor: "red",
                                    padding: "6px 12px",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    color: "white",
                                  }}
                                  onClick={() =>
                                    setCollapseObjectsAdjustableLoanDetails(
                                      (prevObjects) =>
                                        prevObjects.filter(
                                          (_, i) => i !== index
                                        )
                                    )
                                  }
                                >
                                  Remove
                                </div>
                              </div>
                            }
                          >
                            {groupedFieldsItemKeys.map((ItemKey) => {
                              // console.log(
                              //   "groupedFields[grpField][ItemKey]",
                              //   groupedFields[grpField][ItemKey]
                              // );

                              // console.log(
                              //   "groupedFields[grpField][ItemKey][subType]",
                              //   groupedFields[grpField][ItemKey]["subType"]
                              // );
                              switch (
                                adjustableLoanDetails[grpField][ItemKey][
                                  "subType"
                                ]
                              ) {
                                case "array":
                                  return SubFieldGenerator(
                                    adjustableLoanDetails[grpField][ItemKey]
                                  );

                                  break;
                                case "single":
                                  return SubFieldGenerator(
                                    adjustableLoanDetails[grpField][ItemKey]
                                  );
                                  break;

                                default:
                                  return <h1>default type Detected</h1>;
                                  break;
                              }
                            })}
                          </Panel>
                        </Collapse>
                      </div>
                    ))}
                  </>
                )}
                {activeTabName === "ADJUSTABLE LOAN" &&
                adjustableLoanDetails ? (
                  <div
                    onClick={handleAdjustableLoanDetails}
                    style={{
                      backgroundColor: "#2A3DA3",
                      padding: "10px 20px",
                      borderRadius: "10px",
                      float: "left",
                      margin: "1% 3rem",
                      cursor: "pointer",
                      color: "white",
                    }}
                  >
                    Add +
                  </div>
                ) : (
                  ""
                )}
              </>
            );
          })}
      </div>
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}

      {/* <div>
        {groupedFieldsPage(adjustableLoanDetails) == activeTabName &&
          Object.keys(adjustableLoanDetails).map((grpField, index) => {
            const groupedFieldsItemKeys = Object.keys(
              adjustableLoanDetails[grpField]
            );
            groupedFieldsItemKeys.map((ItemKey) => {
              switch (adjustableLoanDetails[grpField][ItemKey]["subType"]) {
                case "array":
                  // console.log("type arayyyyyyyyyyyyyyyy");
                  return (
                    <>
                      <h1>array type Detected</h1>
                    </>
                  );
                  break;
                case "single":
                  // console.log("type singleeeeeeeee");

                  return (
                    <>
                      <h1>single type Detected</h1>
                    </>
                  );
                  break;

                default:
                  return <h1>default type Detected</h1>;
                  break;
              }
            });

            return (
              <>
                <h1
                  style={{
                    margin: " 2rem  3rem",
                    fontFamily: "Poppins",
                    fontSize: "20px",
                    fontWeight: "500",
                    color: "#030229",
                  }}
                >
                  {Object.keys(adjustableLoanDetails)[index]}
                </h1>
                <div style={{ margin: " 0 3rem", width: "50rem" }}>
                  <Collapse>
                    <Panel header={Object.keys(adjustableLoanDetails)[index]}>
                      {groupedFieldsItemKeys.map((ItemKey) => {
                        // console.log(
                        //   "groupedFields[grpField][ItemKey]",
                        //   groupedFields[grpField][ItemKey]
                        // );

                        // console.log(
                        //   "groupedFields[grpField][ItemKey][subType]",
                        //   groupedFields[grpField][ItemKey]["subType"]
                        // );
                        switch (
                          adjustableLoanDetails[grpField][ItemKey]["subType"]
                        ) {
                          case "array":
                            return SubFieldGenerator(
                              adjustableLoanDetails[grpField][ItemKey]
                            );

                            break;
                          case "single":
                            return SubFieldGenerator(
                              adjustableLoanDetails[grpField][ItemKey]
                            );
                            break;

                          default:
                            return <h1>default type Detected</h1>;
                            break;
                        }
                      })}
                    </Panel>
                  </Collapse>
                </div>
              </>
            );
          })}
        </div> */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}

      <div>
        {groupedFieldsPage(additionalLoanInformation) == activeTabName &&
          Object.keys(additionalLoanInformation).map((grpField, index) => {
            const groupedFieldsItemKeys = Object.keys(
              additionalLoanInformation[grpField]
            );
            groupedFieldsItemKeys.map((ItemKey) => {
              switch (additionalLoanInformation[grpField][ItemKey]["subType"]) {
                case "array":
                  // console.log("type arayyyyyyyyyyyyyyyy");
                  return (
                    <>
                      <h1>array type Detected</h1>
                    </>
                  );
                  break;
                case "single":
                  // console.log("type singleeeeeeeee");

                  return (
                    <>
                      <h1>single type Detected</h1>
                    </>
                  );
                  break;

                default:
                  return <h1>default type Detected</h1>;
                  break;
              }
            });

            return (
              <>
                <h1
                  style={{
                    margin: " 2rem  3rem",
                    fontFamily: "Poppins",
                    fontSize: "20px",
                    fontWeight: "500",
                    color: "#030229",
                  }}
                >
                  {Object.keys(additionalLoanInformation)[index]}
                </h1>
                <div style={{ margin: " 0 3rem", width: "50rem" }}>
                  <Collapse>
                    <Panel
                      header={Object.keys(additionalLoanInformation)[index]}
                    >
                      {groupedFieldsItemKeys.map((ItemKey) => {
                        // console.log(
                        //   "groupedFields[grpField][ItemKey]",
                        //   groupedFields[grpField][ItemKey]
                        // );

                        // console.log(
                        //   "groupedFields[grpField][ItemKey][subType]",
                        //   groupedFields[grpField][ItemKey]["subType"]
                        // );
                        switch (
                          additionalLoanInformation[grpField][ItemKey][
                            "subType"
                          ]
                        ) {
                          case "array":
                            return SubFieldGenerator(
                              additionalLoanInformation[grpField][ItemKey]
                            );

                            break;
                          case "single":
                            return SubFieldGenerator(
                              additionalLoanInformation[grpField][ItemKey]
                            );
                            break;

                          default:
                            return <h1>default type Detected</h1>;
                            break;
                        }
                      })}
                    </Panel>
                  </Collapse>
                </div>
              </>
            );
          })}
      </div>
      {/*  */}
      {/*  */}
      {/*  */}
      <div>
        {console.log(
          "additionalCreditCardInformation",
          additionalCreditCardInformation,
          dataObjectInfo
        )}

        {groupedFieldsPage(additionalCreditCardInformation) == activeTabName &&
          Object.keys(additionalCreditCardInformation).map(
            (grpField, index) => {
              const groupedFieldsItemKeys = Object.keys(
                additionalCreditCardInformation[grpField]
              );
              groupedFieldsItemKeys.map((ItemKey) => {
                switch (
                  additionalCreditCardInformation[grpField][ItemKey]["subType"]
                ) {
                  case "array":
                    // console.log("type arayyyyyyyyyyyyyyyy");
                    return (
                      <>
                        <h1>array type Detected</h1>
                      </>
                    );
                    break;
                  case "single":
                    // console.log("type singleeeeeeeee");

                    return (
                      <>
                        <h1>single type Detected</h1>
                      </>
                    );
                    break;

                  default:
                    return <h1>default type Detected</h1>;
                    break;
                }
              });

              return (
                <>
                  <h1
                    style={{
                      margin: " 2rem  3rem",
                      fontFamily: "Poppins",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#030229",
                    }}
                  >
                    {console.log("Object of keys", groupedFieldsItemKeys)}
                    {Object.keys(additionalCreditCardInformation)[index]}
                  </h1>
                  <div style={{ margin: " 0 3rem", width: "50rem" }}>
                    <Collapse>
                      <Panel
                        header={
                          Object.keys(additionalCreditCardInformation)[index]
                        }
                      >
                        {orderOfNamesInfo.map((ItemKey) => {
                          // console.log(
                          //   "ItemKey2222222",
                          //   ItemKey,
                          //   dataObjectInfo[ItemKey],
                          //   dataObjectInfo
                          // );

                          switch (
                            dataObjectInfo &&
                            dataObjectInfo[ItemKey] &&
                            dataObjectInfo[ItemKey]["subType"]
                          ) {
                            case "array":
                              return SubFieldGenerator(dataObjectInfo[ItemKey]);

                              break;
                            case "single":
                              return SubFieldGenerator(dataObjectInfo[ItemKey]);
                              break;

                            default:
                              return <h1>default type Detected</h1>;
                              break;
                          }
                        })}
                      </Panel>
                    </Collapse>
                  </div>
                </>
              );
            }
          )}
      </div>
      <NewLoader isLoading={loading} />
    </>
  );
};

const TabNavigationComponent = ({
  tabs,
  activeTabIndex,
  currentTab,
  activeTabName,
  setActiveTabName,
  AllTabs,
  activeStep1,
  module,
  typeOfLoanValue,
}) => {
  const [alltabs, setAllTabs] = useState(AllTabs);
  const [tabNames, setTabNames] = useState([]);
  const [activeStep, setActiveStep] = useState(activeStep1);
  useEffect(() => {
    if (module === "Real Estate") {
      let temp2 = Object.keys(alltabs);
      temp2.map((tab) => {
        if (tabNames.includes(tab)) {
          setAllTabs((prevValue) => ({
            ...prevValue,
            [tab]: { ...prevValue[tab], enabled: true },
          }));
        }
      });
    } else {
      if (typeOfLoanValue === true) {
        console.log("valueee true");
        let temp2 = Object.keys(alltabs);
        temp2.map((tab) => {
          if (tabNames.includes(tab)) {
            setAllTabs((prevValue) => ({
              ...prevValue,
              ["ADJUSTABLE LOAN"]: {
                ...prevValue["ADJUSTABLE LOAN"],
                enabled: true,
              },
              [tab]: { ...prevValue[tab], enabled: true },
            }));
          }
        });
      } else if (typeOfLoanValue === false) {
        let temp2 = Object.keys(alltabs);
        temp2.map((tab) => {
          if (tabNames.includes(tab)) {
            console.log(
              "valueee is false inside",
              tabs,
              typeOfLoanValue,
              alltabs
            );
            setAllTabs((prevValue) => ({
              ...prevValue,
              [tab]: {
                ...prevValue[tab],
                enabled: true, // Enable the selected tab
              },
              "ADJUSTABLE LOAN": {
                ...prevValue["ADJUSTABLE LOAN"],
                enabled: false, // Ensure ADJUSTABLE LOAN is always disabled
              },
            }));
          }
        });
      }
    }
  }, [tabs, typeOfLoanValue]);
  console.log("alltabs", module, alltabs, typeOfLoanValue, tabs);

  // console.log("typeOfLoanValue", typeOfLoanValue);

  useEffect(() => {
    let temp = tabs.map((tab) => tab.toUpperCase());
    setTabNames(temp);
  }, [tabs]);
  console.log("Tabbbbb", tabs, alltabs);
  // useEffect(() => {
  //   let temp2 = Object.keys(alltabs);
  //   temp2.map((tab) => {
  //     if (tabNames.includes(tab)) {
  //       setAllTabs((prevValue) => ({
  //         ...prevValue,
  //         [tab]: { ...prevValue[tab], enabled: true },
  //       }));
  //     }
  //   });
  // }, [tabs]);

  useEffect(() => {}, [alltabs]);
  useEffect(() => {
    setActiveStep(activeStep1);
  }, [tabs, activeStep1]);
  return (
    <div>
      <Styles.TabContainer>
        {Object.keys(alltabs).map((tabName, tabIndex) => {
          return (
            <Fragment key={tabIndex}>
              {tabIndex > 0 && (
                <Styles.SpacerLine
                  activeIndex={activeStep}
                  currentIndex={tabIndex}
                ></Styles.SpacerLine>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "70px",
                }}
              >
                {console.log("activetab liab", activeTabIndex)}
                <Styles.TabBox
                  onClick={() => {
                    if (alltabs[tabName].enabled) {
                      currentTab(alltabs[tabName].name);
                      setActiveTabName(alltabs[tabName].name);
                      setActiveStep(tabIndex);
                    }
                  }}
                  activeIndex={activeStep}
                  currentIndex={tabIndex}
                  activeStep1={activeStep1}
                  activeTabIndex={activeTabIndex}
                  isActive={alltabs[tabName].name == activeTabName}
                  isEnabled={alltabs[tabName].enabled}
                >
                  {/* {console.log(
                    "  activeTabIndex >= tabIndex && alltabs[tabName].enabled",
                    activeTabIndex,
                    tabIndex,
                    alltabs[tabName].enabled
                  )} */}
                  <Styles.TabBoxNumber>
                    {alltabs[tabName].priority}
                  </Styles.TabBoxNumber>
                </Styles.TabBox>
                <p style={{ margin: "10px 0", textAlign: "center" }}>
                  {(alltabs[tabName].name &&
                    alltabs[tabName].name === "ADDITIONAL INFORMATION" &&
                    "AMOUNTS AND PAYMENTS") ||
                    (alltabs[tabName].name &&
                      alltabs[tabName].name === "LOAN" &&
                      "LOAN PAYBACK TYPE") ||
                    (alltabs[tabName].name &&
                      alltabs[tabName].name === "ADJUSTABLE LOAN" &&
                      "ADJUSTABLE LOAN DETAILS") ||
                    (alltabs[tabName].name &&
                      alltabs[tabName].name === "PAYMENTS" &&
                      "ADDITIONAL PAYMENT DETAILS") ||
                    alltabs[tabName].name}
                </p>
              </div>
            </Fragment>
          );
        })}
      </Styles.TabContainer>
    </div>
  );
};

export default LiabilitySubForm;
//
//
